/**
 * @author wuTao
 * @description 班级助手
 * @Date 2020/2/27
 */
import React from 'react';
import moment from 'moment';
import {connect} from 'dva';
import {component_tool, framework_tool, utils_tool} from '@/tool';
import {WizTableForm} from '@/containers/common';
import {Col, message, Row, Spin} from 'antd'

import SurveyTemplatePreview from "../../../biz/surveyTemplate/surveyTemplatePreview/surveyTemplatePreview";
import '@/styles/containers/face/class/style.less';
import {
  columnsExam,
  columnsHomework,
  columnsQuestion,
  columnsQuestionnaire,
  columnsRemoteAuth,
  columnsSatisfaction,
  columnsSign,
  columnsVideo,
  columnsNEVLive,
  columnsNEVMeeting
} from './columns';
import {classStudentLiveRecordExcelColumns,
  classStudentRemoteAuthExcelColumns,
  classStudentNEVRemoteAuthExcelColumns,
  classStudentStudentExamResultExcelColumns,
  classStudentStudentSurveyDetailExcelColumns
} from '../excelColumns';

import AuthVideo from "../classStudent/classStudentRemoteAuth/authVideo";

let {WizContainer, modelUtils} = framework_tool;
let {WizBrowserExport, WizCard, WizModalForm, WizModal, WizMenu, WizDropdown, WizDataTable, WizTimeline, WizTag, WizIcon, WizButton, WizDivider, WizEmpty, WizAvatar, WizCommonSteps} = component_tool;
let {Session} = utils_tool;
const {CheckableTag} = WizTag;
const formatterDate = (val) => {
  return val ? moment(val).format('YYYYMMDDHHmmss') : '';
}
const formatterAuthDate = (val) => {
  return val ? moment(val).format('YYYY.MM.DD') : '';
}
const formatterTime = (val) => {
  return val ? moment(val).format('HH:mm:ss') : '';
}

const formatterDateTime = (val) => {
  return val ? moment(val).format('YYYY.MM.DD HH:mm:ss') : '';
}

class ClassAideDetail extends WizContainer {

  componentName = 'ClassAideDetail';

  constructor(props) {
    super(props);
    this.state = {
      classId: null,
      aideTypeId: null,
      classAideId: null,
      pushEnterpriseNumber:0,
      aideName: null,
      startTime: null,
      endTime: null,
      stage: null,
      status: null,
      classDate: null,
      entityRecord: null,
      reverse: false,
      smallClassVisible: false,
      questionnaireVisible: false,
      signVisible: false,
      examVisible: false,
      questionVisible: false,
      homeworkVisible: false,
      satisfactionVisible: false,
      remoteAuthVisible: false,
      NEVLiveVisible: false,
      NEVMeetingVisible: false,
      coverImageShow: constants.files.sys_live_default_image,
      liveImg: null,
      signRepairVisible: false,
      signId: null,
      signTime: '',
      tempPreviewVisible: false,//查看问卷模版
      templateData: {}, //问卷模版数据
      homeworkDate: undefined,
      homeworkName: undefined,
      satisfactionName: undefined,
      examName: undefined,
      beforeStage: true,
      middleStage: true,
      afterStage: true,
      beforeStageIcon: 'up',
      middleStageIcon: 'up',
      afterStageIcon: 'up',
      autoRecording: 0,
      hostVideo: 0,
      participantVideo: 0,
      waitingRoom: 0,
      muteUponEntry: 0,
      joinBeforeHost: 0,
      interactLiveTypeKey: new Date().getTime(),
      personIds: [],//班级现有学员personIds
      disabled:false,
      modalClassAideKey: new Date().getTime(),
      excelName:'环节记录信息',
      checkDateInfo : '',
      videoVisible : null,
      ownerId : undefined,
      showHkt:true, //是否展示慧课堂配置
    };
    this.initialValue = {};
    this.aideTypeList = [];
    this.aideTypeMap = [];
    //this.getAideTypeList();
    this.personInfo = [];
    this.remoteAuthTypeId = null;
    this.remoteAuthIdList = null;
    this.remoteAuthTypeIdNEV = null;
    this.remoteAuthIdListNEV = null;
  }

  _componentWillMount() {
    const {history} = this.props;
    if (history.location && history.location.pathname === '/face/classList/classAideDetail') {
      if (history.location.record) {
        Session.add('classInfoRecord', history.location.record);
        this.initialValue = history.location.record;
        this.setState({classId: this.initialValue.id})
      } else if (Session.get('classInfoRecord')) {
        this.initialValue = Session.get('classInfoRecord') ? Session.get('classInfoRecord') : {};
        this.setState({classId: this.initialValue.id})
      }
      this.getAideTypeList(this.initialValue.programCategory);
      if (this.initialValue.id) {
        this.getClassAideList();
      }
      if (this.initialValue.id) {
        this.getClassInfoById();
      }
    }
  }

  /**获取班级对应的学员personIds数据 */
  getClassStudentPersonIdsList() {
    this.doAction({
      path: 'classStudentManagement/getPersonIdsByClassInfoId',
      payload: {
        key: 'classStudentPersonIds',
        apiParams: {
          id: this.initialValue.id,
        }
      }
    });
  }

  propsAndStateOnChange = {
    classAideList: this._getClassAideListOver.bind(this),
    saveEntityInfo: this._saveEntityInfoOver.bind(this),
    aideTypeList: this._getAideTypeListOver.bind(this),
    updateClassAideStatus: this._updateClassAideStatusOver.bind(this),
    personInfo: this._getPersonInfoOver.bind(this),
    deleteClassAide: this._deleteClassAideOver.bind(this),
    setStudentSignStatusByBatch: this.updateStudentSignStatusOver.bind(this),
    classStudentExamDetail: this._handleFile.bind(this),
    exportClassStudentSurveyDetailByCondition: this._handleSurveyFile.bind(this),
    classStudentPersonIds: this._getClassStudentPersonIdsOver.bind(this),
    classStudentRemoteAuth: this._handleClassStudentRemoteAuthFile.bind(this),
    classStudentNEVRemoteAuth: this._handleClassStudentNEVRemoteAuthFile.bind(this),
    classStudentLiveRecord: this._handleClassStudentLiveRecordFile.bind(this),
    exportClassStudentSurveyByCondition: this._handleSatisfactionFile.bind(this),
    exportClassStudentHomework: this._handleHomeworkFile.bind(this),
    setInteractLiveState: this._setInteractLiveStateOver.bind(this),
    checkMeetingDate: this._checkMeetingDateOver.bind(this),
    getClassInfoById: this._getClassInfoByIdOver.bind(this),
    labelInfo: this._labelInfo.bind(this)
  };

  //查询所有app
  _labelInfo(nextProps, nextState) {
    let { labelInfo } = nextProps
    if (labelInfo && labelInfo['success']) {
      nextState['labelInfo'] = labelInfo['data'];
      return true
    } else {
      wizNotice.error(labelInfo && labelInfo['msg'] || '操作失败,请稍后尝试')
      return false
    }
  }
  _getClassStudentPersonIdsOver(nextProps, nextState) {
    if (nextProps.classStudentPersonIds.code == 1) {
      this.setState({
        personIds: nextProps.classStudentPersonIds.data ? nextProps.classStudentPersonIds.data : []
      });
    }
    return true;
  }

  _handleClassStudentRemoteAuthFile(nextProps, nextState) {
    let o = nextProps.classStudentRemoteAuth;
    let columns = classStudentRemoteAuthExcelColumns;
    if (o['success']) {
      let data = o['data'];
      let _data = [];
      //对需要转换的信息进行转换，如枚举
      data && data.forEach(d => {
        let _d = { ...d };
        _d.jobState = d.jobState ===1 ? "在职" : d.jobState ===0 ?  "离职" : "";
        _d.leaveState = d.leaveState ===1 ? "是" : d.leaveState ===0 ?  "否" : "";
        _d.authDate = d.authDate ? formatterAuthDate(d.authDate) : "";
        _d.authTime = (d.startDate ? formatterTime(d.startDate) + ' ~ ' : '') + (d.endDate ? formatterTime(d.endDate) : '');
        _d.isConfig = d.isConfig ===1 ? "是" : d.isConfig ===0 ?  "否" : "";
        _d.authState = d.authState ===0 ? "未开始" : d.authState ===1 ?  "已开始" : d.authState ===2 ?  "认证中" : d.authState ===3 ?  "未参考" : d.authState ===4 ?  "已完成" :  d.authState ===6 ?  "已作废" :"可回看";
        _d.pass = d.pass ===1 ? "已通过" : d.pass ===0 ?  "未通过" : "";
        _data.push(_d);
      });
      WizBrowserExport({
        title: '班级学员远程认证记录信息',
        sheetName: '班级学员远程认证记录信息',
        columns: columns.filter((_, index) => index),
        rows: _data,
        filename: '班级学员远程认证记录信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleClassStudentNEVRemoteAuthFile(nextProps, nextState) {
    let o = nextProps.classStudentNEVRemoteAuth;
    let columns = classStudentNEVRemoteAuthExcelColumns;
    if (o['success']) {
      let data = o['data'];
      let _data = [];
      //对需要转换的信息进行转换，如枚举
      data && data.forEach(d => {
        let _d = { ...d };
        _d.jobState = d.jobState ===1 ? "在职" : d.jobState ===0 ?  "离职" : "";
        _d.leaveState = d.leaveState ===1 ? "是" : d.leaveState ===0 ?  "否" : "";
        _d.authDate = d.authDate ? formatterAuthDate(d.authDate) : "";
        _d.authTime = (d.startDate ? formatterTime(d.startDate) + ' ~ ' : '') + (d.endDate ? formatterTime(d.endDate) : '');
        _d.isConfig = d.isConfig ===1 ? "是" : d.isConfig ===0 ?  "否" : "";
        _d.authState = d.authState ===0 ? "未开始" : d.authState ===1 ?  "已开始" : d.authState ===2 ?  "认证中" : d.authState ===3 ?  "未参考" : d.authState ===4 ?  "已完成" :  d.authState ===6 ?  "已作废" :"可回看";
        _d.pass = d.pass ===1 ? "已通过" : d.pass ===0 ?  "未通过" : "";
        _data.push(_d);
      });
      WizBrowserExport({
        title: '班级学员NEV认证记录信息',
        sheetName: '班级学员NEV认证记录信息',
        columns: columns.filter((_, index) => index),
        rows: _data,
        filename: '班级学员NEV认证记录信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleClassStudentLiveRecordFile(nextProps, nextState) {
    let o = nextProps.classStudentLiveRecord;
    let columns = classStudentLiveRecordExcelColumns;
    if (o['success']) {
      let data = o['data'];
      let _data = [];
      //对需要转换的信息进行转换，如枚举
      data && data.forEach(d => {
        let _d = { ...d };
        _d.jobState = d.jobState ===1 ? "在职" : d.jobState ===0 ?  "离职" : "";
        _d.leaveState = d.leaveState ===1 ? "是" : d.leaveState ===0 ?  "否" : "";
        _d.isAttend = d.isAttend ===1 ? "是" : d.isAttend ===0 ?  "否" : "";
        _d.startTime = d.startTime ? formatterDateTime(d.startTime) : "";
        _d.endTime = d.endTime ? formatterDateTime(d.endTime) : "";
        _d.duration = d.duration ? d.duration : "";
        _data.push(_d);
      });
      WizBrowserExport({
        title: this.state.excelName,
        sheetName: this.state.excelName,
        columns: columns.filter((_, index) => index),
        rows: _data,
        filename: this.state.excelName+'.xlsx',
      })
      this.setState({
        excelName:'环节记录信息'
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      this.setState({
        excelName:'环节记录信息'
      })
      return false;
    }
  }

  /**导出 */
  _handleFile(nextProps, nextState, key) {
    let o = nextProps.classStudentExamDetail;
    let columnDefs = classStudentStudentExamResultExcelColumns
    if (o['success']) {
      let data = o['data'];
      WizBrowserExport({
        title: '班级考试成绩信息',
        sheetName: '班级考试成绩信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '班级考试成绩信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  _handleSatisfactionFile(nextProps, nextState, key) {
    let o = nextProps['exportClassStudentSurveyByCondition'];
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '手机号',
        field: 'mobile',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '身份证号/工号',
        field: 'idCard',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '组织名称',
        field: 'orgName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '组织编码',
        field: 'orgCode',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '岗位',
        field: 'positionName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '任职状态',
        field: 'jobStateName',
        width: 12,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '是否答卷',
        field: 'isJoinSurveyName',
        width: 12,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '是否请假',
        field: 'leaveStateStr',
        width: 12,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '答卷时间',
        field: 'submissionDate',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '满意度评分',
        field: 'scoreAvg',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
    ]
    if (o['success']) {
      let data = o['data'];
      let dataNew = data;
      if(data && data.length>0){
        dataNew = [];
        let questionIds = [];
        data.forEach(element=>{
          if(element.questions && element.questions.length) {
            element.questions.forEach(e => {
              if(questionIds.indexOf(e.title) <= -1){
                columnDefs.push({
                  headerName: e['title'],
                  field: e['title'],
                  width: 20,
                  cellStyle: {
                    textAlign: 'center',
                  },
                  style: {
                    alignment: { vertical: 'bottom', horizontal: 'left' },
                  }
                })
                questionIds.push(e.title);
              }
             // element[e.title]=e.answer
             let answerOptions = []
             let title = new Set();
             if (e['answerOptions'] && e['answerOptions'].length) {
               answerOptions = e['answerOptions']
               answerOptions.forEach(a => {
                 if (a['content']) {
                   title.add(a['content'])
                 }
               })
             }else {
               if (e['answer']) {
                 title.add(e['answer'])
               }
             }
             if (e['otherAnswer'] && e['otherAnswer'].length) {
               title.add(e['otherAnswer'])
             }
             element[e['title']] = Array.from(title).toString();
            })
          }
          element.leaveStateStr = element.leaveState ===0 ? '否' : "是"
          dataNew.push(element);
        })
      }
      WizBrowserExport({
        title: '班级问卷信息',
        sheetName: '班级问卷信息',
        columns: columnDefs.filter((_, index) => index),
        rows: dataNew,
        filename: '班级问卷信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  _handleHomeworkFile(nextProps, nextState, key) {
    let o = nextProps['exportClassStudentHomework'];
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '手机号',
        field: 'mobile',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },

      {
        headerName: '组织名称',
        field: 'orgName',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '组织代码',
        field: 'orgCode',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      {
        headerName: '岗位',
        field: 'positionName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      {
        headerName: '在职状态',
        field: 'jobStateName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      {
        headerName: '是否请假',
        field: 'leaveStateStr',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      {
        headerName: '是否参加',
        field: 'isAttendStr',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      {
        headerName: '提交时间',
        field: 'submitTime',
        width: 18,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      {
        headerName: '通过状态',
        field: 'passStr',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      {
        headerName: '标签',
        field: 'labelNames',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      {
        headerName: '成绩',
        field: 'score',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },


    ]
    if (o['success']) {
      let data = o['data'];
      let dataNew = [];
      if(data){
        data.forEach(element => {
          element.jobStateName = element.jobState ===1 ? "在职" : element.jobState ===0 ?  "离职" : ""
          element.leaveStateStr = element.leaveState ===1 ? "是" : element.leaveState ===0 ?  "否" : ""
          element.isAttendStr = element.isAttend ===1 ? "是" : element.isAttend ===0 ?  "否" : ""
          element.passStr = element.pass ===1 ? "通过" : element.pass ===0 ?  "未通过" : ""
          dataNew.push(element);
        });
      }
      WizBrowserExport({
        title: '班级作业记录信息',
        sheetName: '班级作业记录信息',
        columns: columnDefs.filter((_, index) => index),
        rows: dataNew,
        filename: '班级作业记录信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  /**导出 问卷答题详情*/
  _handleSurveyFile(nextProps, nextState) {
    let o = nextProps.exportClassStudentSurveyDetailByCondition;
    let columnDefs = classStudentStudentSurveyDetailExcelColumns;
    if (o['success']) {
      let data = o['data'];
      let titleMaplist = data.titleMaplist;
      let data_ = data.data;
      let totleCount = data.totleCount;
      let openCount = data.openCount;
      let submitCount = data.submitCount;

      if (titleMaplist && titleMaplist instanceof Array) {
        titleMaplist.forEach(element => {
          element.width = 20;
          element.cellStyle = {
            textAlign: 'center',
          }
          element.style = {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          }
          //columnDefs[1].children.push({ ...element })
          columnDefs.push({...element})
        });
      }
      //columnDefs[1].headerName = '总人数: ' + totleCount + '\n' + '已打开人数: ' + openCount +'\n' + '已提交人数: ' + submitCount,
      WizBrowserExport({
        title: '班级总人数: ' + totleCount + '\n' + '已打开人数: ' + openCount + '\n' + '已提交人数: ' + submitCount,
        sheetName: '班级问卷信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data_,
        filename: '班级问卷信息.xlsx',
        titleParams: {
          alignment: {vertical: 'bottom', horizontal: 'left', wrapText: true},
          style: {
            alignment: {vertical: "bottom", horizontal: "left", wrapText: true},
          },
          font: {},
        },
        titleRow: {
          height: 60
        }
        //rowMergeCell:['A2:G2'],
      })
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  /**
   * 批量补签返回结果
   * @param nextProps
   * @param nextState
   */
  updateStudentSignStatusOver(nextProps, nextState) {
    if (nextProps.setStudentSignStatusByBatch.code == 1) {
      wizNotice.success('补签成功');
      this.getClassAideList();
      this.setState({
        signRepairVisible: false,
        signId: null,
        signTime: '',
      });
    } else {
      wizNotice.error('补签失败：' + nextProps.setStudentSignStatusByBatch.msg);
    }
  }

  _getClassAideListOver(nextProps, nextState) {
    if (nextProps.classAideList.code == 1) {
      let classAideList = nextProps.classAideList.data;
      this.initialValue.classAideList = classAideList;
      let remoteAuthIdList = []
      let remoteAuthIdListNEV = []
      if (classAideList!=null && classAideList instanceof Array && classAideList.length>0){
        let remoteAuthTypeId = this.remoteAuthTypeId;
        let remoteAuthTypeIdNEV = this.remoteAuthTypeIdNEV;
        classAideList.map((classAide) => {
          const {entityId, aideTypeId } = classAide;
          if (aideTypeId === remoteAuthTypeId){
            remoteAuthIdList.push(entityId);
          }else if(aideTypeId === remoteAuthTypeIdNEV){
            remoteAuthIdListNEV.push(entityId);
          }
        })
      }
      this.remoteAuthIdList = remoteAuthIdList;
      this.remoteAuthIdListNEV = remoteAuthIdListNEV;
    }
    return true;
  }

  _getClassInfoByIdOver(nextProps, nextState) {
    if (nextProps.getClassInfoById.code == 1) {
      let getClassInfoById = nextProps.getClassInfoById.data;
      this.initialValue.studentCount = getClassInfoById.studentCount;
    }
    return true;
  }

  _getAideTypeListOver(nextProps, nextState) {
    if (nextProps.aideTypeList.code == 1) {
      let aideTypeList = nextProps.aideTypeList.data;
      let aideTypeMap = [];
      let remoteAuthTypeId = null;
      let remoteAuthTypeIdNEV = null;
      if (aideTypeList) {
        aideTypeList.map((aideType) => {
          const {id, code } = aideType;
          aideTypeMap[id] = aideType;
          if ('remoteAuth' === code){
            remoteAuthTypeId = id;
          }else if('NEVLive' === code){
            remoteAuthTypeIdNEV = id;
          }
        })
      }
      this.remoteAuthTypeId = remoteAuthTypeId;
      this.remoteAuthTypeIdNEV = remoteAuthTypeIdNEV;
      this.aideTypeList = aideTypeList;
      this.aideTypeMap = aideTypeMap;
    }
    return true;
  }

  _saveEntityInfoOver(nextProps, nextState) {
    nextState.classAideId = null;
    nextState.pushEnterpriseNumber = 0;
    nextState.aideTypeId = null;
    nextState.entityRecord = null;
    if (nextProps.saveEntityInfo.code == 1) {
      nextState.homeworkDate = null;
      nextState.homeworkName = null;
      nextState.satisfactionName = null;
      nextState.examName = null,
      nextState.entityRecord = null;
      nextState.checkDateInfo = null;
      wizNotice.success('保存成功');
      this.getClassAideList();
    } else {
      wizNotice.error('提交失败：' + nextProps.saveEntityInfo.msg);
    }
    return true;
  }

  /**
   * 将查询到的人员选项加载到记录中
   */
  _getPersonInfoOver(nextProps, nextState) {
    let personInfo = nextProps.personInfo.data;
    if (nextProps.personInfo.code == 1 && personInfo && personInfo.length) {
      this.personInfo = personInfo;
    }
    this.setState({
      smallClassVisible: true
    });
    return true;
  }

  _updateClassAideStatusOver(nextProps, nextState) {
    if (nextProps.updateClassAideStatus.code == 1) {
      wizNotice.success('修改成功');
      this.getClassAideList();
    } else {
      wizNotice.error('修改失败：' + nextProps.updateClassAideStatus.msg);
    }
    return true;
  }

  _setInteractLiveStateOver(nextProps, nextState) {
    if (nextProps.setInteractLiveState.code == 1) {
      wizNotice.success('修改成功');
      this.getClassAideList();
    } else {
      wizNotice.error('修改失败：' + nextProps.setInteractLiveState.msg);
    }
    return true;
  }

  _deleteClassAideOver(nextProps, nextState) {
    if (nextProps.deleteClassAide.code == 1) {
      wizNotice.success('删除成功');
      this.getClassAideList();
    } else {
      wizNotice.error('删除失败：' + nextProps.deleteClassAide.msg);
    }
    return true;
  }

  _checkMeetingDateOver(nextProps, nextState) {
    if (nextProps.checkMeetingDate.code == 1) {
      nextState.checkDateInfo = nextProps.checkMeetingDate.data
    } else {

    }
    return true;
  }

  /**获取对应的助手流程数据 */
  getClassAideList() {
    this.doAction({
      path: 'classAideManagement/getAllClassAideInfoByClassId',
      payload: {
        key: 'classAideList',
        apiParams: {
          classId: this.initialValue.id,
          isOrderNum: true
        }
      }
    });
  }

  /**获取班级最新班级学员数量 */
  getClassInfoById() {
    this.doAction({
      path: 'classAideManagement/getClassInfoById',
      payload: {
        key: 'getClassInfoById',
        apiParams: {
          id: this.initialValue.id,
          isOrderNum: true
        }
      }
    });
  }

  /**获取对应的讲师数据，讲师选择组件需要显示默认值 */
  getPersonInfoByPersonIdList(lectureIds) {
    if (lectureIds && lectureIds.length) {
      this.doAction({
        path: 'personManage/getPersonInfoByPersonIdList',
        payload: {
          key: 'getPersonInfoByPersonIdList',
          apiParams: {
            personIdList: lectureIds,
          }
        }
      });
    } else {
      this.setState({
        smallClassVisible: true
      });
    }
  }

  /**获取助手类型 */
  getAideTypeList(programCategory) {
    this.doAction({
      path: 'aideTypeManagement/list',
      payload: {
        key: 'aideTypeList',
        apiParams: {
          status: 0,
          categoryList:[programCategory]
        }
      }
    });
  }

  /**保存方法 */
  _submitEntity(values, aideTypeId, stateType, record) {
    let fitterValues = this.fitterFieldsValue(values, aideTypeId, record);
    let apiPath = "classAideManagement/saveOrUpdateEntityInfo";
    if (!fitterValues) {
      return;
    }
    if(this.state.classAideId && this.state.aideTypeId==1 && (fitterValues.state==3 || fitterValues.state==4)){
      wizNotice.warn( "课堂在进行中或已结束，不可变更");
      return;
    }
    this.setState({
      ...stateType
    })
    this.doAction({
      path: apiPath,
      payload: {
        key: 'saveEntityInfo',
        apiParams: {
          id: this.state.classAideId,
          aideTypeId: this.state.aideTypeId,
          classId: this.state.classId,
          pushEnterpriseNumber: this.state.pushEnterpriseNumber,
          entityRecord: {
            classId: this.state.classId,
            aideTypeId: this.state.aideTypeId,
            pushEnterpriseNumber: this.state.pushEnterpriseNumber,
            ...fitterValues,
          },
        }
      }
    });

  }

  /**
   * 修改班级流程环节状态
   * @param id
   * @param status
   * @private
   */
  _updateClassAideStatus(id, newStatus,aideTypeName,aideTypeId,entityId,classId) {
    let content = `您确定要${newStatus ? '关闭' : '打开'}该${aideTypeName}吗？`;
    if((aideTypeId==1 || aideTypeId==9) && newStatus){
      content = "本环节关闭后系统将自动关闭该"+aideTypeName+",且无法再重新打开,是否确认关闭?"
    }

    if((aideTypeId==8) && newStatus){
      content = "远程认证环节关闭后，环节内的认证设置将作废，您确认要关闭吗？"
    }

    if((aideTypeId==11) && newStatus){
      content = "NEV认证环节关闭后，环节内的认证设置将作废，您确认要关闭吗？"
    }

    //`您确定要${newStatus ? '关闭' : '打开'}该${aideTypeName}吗？`
    WizModal.confirm({
      title: '注意',
      content: content,
      onOk: () => {
        this.doAction({
          path: 'classAideManagement/updateClassAideStatus',
          payload: {
            key: 'updateClassAideStatus',
            apiParams: {
              idList: [id],
              status: newStatus,
              aideTypeId:aideTypeId,
              entityId:entityId,
              classId:classId
            }
          }
        });
      },
      onCancel() {
      }
    });
  }

  /**
   * 班级签到流程环节状态补签
   * @param id
   * @param status
   * @private
   */
  _signRepairClassStudent(signId, signTime) {
    this.setState({
      signRepairVisible: true,
      signId: signId,
      signTime: signTime,
    });
  }

  /**
   * 删除班级流程环节状态
   * @param id
   * @private
   */
  _deleteClassAide(id) {
    this.doAction({
      path: 'classAideManagement/delete',
      payload: {
        key: 'deleteClassAide',
        apiParams: {
          ids: [id]
        }
      }
    });
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param fieldsValue
   */
  fitterFieldsValue(fieldsValue, aideTypeId, record) {
    let fitterValues = {};
    let aideTypeMap = this.aideTypeMap;
    let aideType = aideTypeMap[aideTypeId];
    if (!aideType) {
      return fitterValues;
    }
    const {code} = aideType;
    if (!code) {
      return fitterValues;
    }
    if (fieldsValue['name'] && fieldsValue['name'] != null && fieldsValue['name'] != undefined) {
      if (!fieldsValue['aideName'] || fieldsValue['aideName'] === null ||
        fieldsValue['aideName'] === undefined || fieldsValue['aideName'] === '') {
        fieldsValue['aideName'] = fieldsValue['name'];
      }
    }
    // entityRecord 若有特殊数据 需要单独处理
    if (code === 'smallClass' || code === 'remoteEvaluation' || code === 'NEVMeeting' ) {
      if(record){
        fieldsValue['videoTool']=record.videoTool
      }else{
        fieldsValue['videoTool']=2
      }
      let classDateValue = fieldsValue['classDate']; //环节时间
      fieldsValue['startDate'] = classDateValue[0].format("YYYY-MM-DD HH:mm:ss");
      fieldsValue['endDate'] = classDateValue[1].format("YYYY-MM-DD HH:mm:ss");
      //直播分类
      let liveCategoryIdValue = fieldsValue['liveCategoryId'];
      if (liveCategoryIdValue && liveCategoryIdValue instanceof Array && liveCategoryIdValue.length > 0) {
        fieldsValue['liveCategoryId'] = Number.parseInt(liveCategoryIdValue[0]);
      }
      let authCmd = {}

      if(record && record.authInfo){
        authCmd = record.authInfo
        if(record.authInfo.personIds){
          let personIdsNew = [];
          record.authInfo.personIds.forEach(e=>{
            personIdsNew.push(e.id);
          })
          authCmd.personIds= personIdsNew;
        }
      }else{
        authCmd.orgIds = [];
        authCmd.positionIds = [];
        authCmd.positionCategoryIds = [];
        authCmd.personIds = [];
      }
      if (fieldsValue['personIds']) {
        let personIds = fieldsValue['personIds'];
        // authCmd.orgIds = [];
        // authCmd.positionIds = [];
        // authCmd.positionCategoryIds = [];
        // authCmd.personIds = personIds;
        if (personIds != null && personIds instanceof Array && personIds.length > 25) {
          wizNotice.warn("班级人数超过25人，不能创建该环节,请确认后重试!");
          return null;
        }
      } else {
        // authCmd.orgIds = [];
        // authCmd.positionIds = [];
        // authCmd.positionCategoryIds = [];
        // authCmd.personIds = [];
      }

      if (fieldsValue['img'] && fieldsValue['img'].length===0 ) {
        fieldsValue['img']="";
      }

      fieldsValue['authCmd'] = authCmd;

      if(fieldsValue['videoTool']==2){
        fieldsValue['isHostCamera'] =  fieldsValue['isHostCamera'] && fieldsValue['isHostCamera'][0] ? 1:0
        fieldsValue['isHostMic'] = fieldsValue['isHostMic'] && fieldsValue['isHostMic'][0] ? 1:0
        fieldsValue['isParticipantPlatform'] = fieldsValue['isParticipantPlatform'] && fieldsValue['isParticipantPlatform'][0] ? 1:0
        fieldsValue['isAllowCamera']= fieldsValue['isAllowCamera'] && fieldsValue['isAllowCamera'][0] ? 1:0
        fieldsValue['isParticipantCamera'] = fieldsValue['isParticipantCamera'] && fieldsValue['isParticipantCamera'][0] ? 1:0
        fieldsValue['isAllowMic'] = fieldsValue['isAllowMic'] && fieldsValue['isAllowMic'][0] ? 1:0
        fieldsValue['isParticipantMic']= fieldsValue['isParticipantMic'] && fieldsValue['isParticipantMic'][0] ? 1:0
        fieldsValue['isFollowHost'] = fieldsValue['isFollowHost'] && fieldsValue['isFollowHost'][0] ? 1:0
  
      }

    } else if (code === 'questionnaire') {

    } else if (code === 'sign') {
      let signId = null;
      let signTimesId = null;
      let startDate = null;
      let endDate = null;
      let signTimesList = null;
      let signTimes = null;
      if (fieldsValue['id']) {
        signId = fieldsValue['id'];
      }
      if (fieldsValue['signTimesId']) {
        signTimesId = fieldsValue['signTimesId'];
      }
      if (fieldsValue && fieldsValue['signDate'] && fieldsValue['signDate'].length) {
        let signDateValue = fieldsValue['signDate'];
        startDate = signDateValue[0].format("YYYY-MM-DD HH:mm:ss");
        endDate = signDateValue[1].format("YYYY-MM-DD HH:mm:ss");
      }
      if ((signTimesId && signId) || startDate || endDate) {
        signTimes = {
          id: signTimesId,
          startDate: startDate,
          endDate: endDate,
          signId: signId,
        };
      }
      if (signTimes) {
        signTimesList = [];
        signTimesList[0] = signTimes;
      }
      fieldsValue['signTimesList'] = signTimesList;
    } else if (code === 'exam') {

    } else if (code === 'question') {

    } else if (code === 'homework') {
      let startDate = null;
      let endDate = null;
      if (record) {
        startDate = new Date(record.startDate);//作业开始时间
        endDate = new Date(record.endDate);//作业结束时间
      } else {
        let arrayDate = this.state.homeworkDate.split('~');
        startDate = new Date(arrayDate[0]);
        endDate = new Date(arrayDate[1]);
      }
      let classDateValue = fieldsValue['classDate']; //环节时间
      let aideStartDate = new Date(classDateValue[0]);
      let aideEndDate = new Date(classDateValue[1]);
      if(!(startDate<aideStartDate && endDate>aideEndDate)){
        wizNotice.warn("环节时间需在作业时间范围内,请确认后重试!");
        return null;
      }
    } else if (code === 'satisfaction') {

    }
    if (fieldsValue['classDate']) {
      let classDateValue = fieldsValue['classDate']; //环节时间
      fieldsValue['classDate'] = [];
      fieldsValue['classDate'].push(classDateValue[0].format("YYYY-MM-DD HH:mm:ss"));
      fieldsValue['classDate'].push(classDateValue[1].format("YYYY-MM-DD HH:mm:ss"));
    }
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      //  若有特殊数据 需要单独先进行处理
      if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    //图片参数处理
    let the_img = fitterValues['img']
    if (the_img && the_img.length) {
      fitterValues['img'] = the_img[0]['fileId']

    }
    return fitterValues;
  };

  /**
   * 操纵打开流程块模态框
   */
  _handleAideTypeTag = (checked, aideType, other) => {
    const {code, id, name} = aideType;
    const {entityRecord} = other;
    let disabled = false;
    if (entityRecord && entityRecord.id && entityRecord.id!=-1){
      disabled = true;
    }
    if (code) {
      if (code === 'smallClass' || code === 'remoteEvaluation') {
        //打开直播课堂及远程评估时获取班级人数personIds
        this.getClassStudentPersonIdsList();
        this.setState({
          ...other,
          aideTypeId: id,
          modalClassAideKey: new Date().getTime(),
          disabled:disabled,
          aideName: name,
          smallClassVisible: true,
          showHkt: !(entityRecord && entityRecord.videoTool==1),
        })
      } else if (code === 'questionnaire') {
        wizNotice.warn("功能暂未开放,敬请期待!")
        // this.setState({
        //   ...other,
        //   aideTypeId: id,
        //   aideName: name,
        //   modalClassAideKey: new Date().getTime(),
        //   questionnaireVisible: true
        // })
      } else if (code === 'sign') {
        wizNotice.warn("功能暂未开放,敬请期待!")
        // this.setState({
        //   ...other,
        //   aideTypeId: id,
        //   aideName: name,
        //   modalClassAideKey: new Date().getTime(),
        //   signVisible: true
        // })
      } else if (code === 'exam') {
        //wizNotice.warn("功能暂未开放,敬请期待!")
        this.setState({
          ...other,
          aideTypeId: id,
          aideName: name,
          modalClassAideKey: new Date().getTime(),
          examVisible: true
        })
      } else if (code === 'question') {
        wizNotice.warn("功能暂未开放,敬请期待!")
        // this.setState({
        //   ...other,
        //   aideTypeId: id,
        //   aideName: name,
        //   modalClassAideKey: new Date().getTime(),
        //   questionVisible: true
        // })
      } else if (code === 'onlineProgram') {
        wizNotice.warn("功能暂未开放,敬请期待!")
        // this.setState({
        //   ...other,
        //   aideTypeId: id,
        //   aideName: name,
        //   modalClassAideKey: new Date().getTime(),
        //   questionVisible: true
        // })
      }else if (code === 'homework') {
        this.setState({
          ...other,
          ...entityRecord,
          aideTypeId: id,
          aideName: name,
          modalClassAideKey: new Date().getTime(),
          homeworkVisible: true
        })
      } else if (code === 'satisfaction') {
        this.setState({
          ...other,
          ...entityRecord,
          aideTypeId: id,
          aideName: name,
          modalClassAideKey: new Date().getTime(),
          satisfactionVisible: true
        },()=>{
          this.doActions([
            {
              path: 'thirdApp/labelInfo',
              payload: {
                key: 'thirdApp@labelInfo',
                apiParams: {
                }
              }
            },
          ])})
      } else if (code === 'remoteAuth') {
        this.setState({
          ...other,
          ...entityRecord,
          aideTypeId: id,
          aideName: name,
          modalClassAideKey: new Date().getTime(),
          remoteAuthVisible: true
        })
      } else if (code === 'NEVLive') {
        this.setState({
          ...other,
          ...entityRecord,
          aideTypeId: id,
          aideName: name,
          modalClassAideKey: new Date().getTime(),
          NEVLiveVisible: true
        })
      }else if (code === 'NEVMeeting') {
        this.setState({
          ...other,
          ...entityRecord,
          aideTypeId: id,
          aideName: name,
          modalClassAideKey: new Date().getTime(),
          NEVMeetingVisible: true
        })
      }else {
        this.setState({
          ...other,
          ...entityRecord,
          aideTypeId: null,
          modalClassAideKey: new Date().getTime(),
          aideName: null
        })
      }
    }
  };

  /**
   * 调整顺序
   */
  changeOrderNum = () => {
    this.setState({reverse: !this.state.reverse});
  };

  /**
   * 展开/收起 阶段环节内容
   */
  isShowStage = (stage) => {
    if (stage === 'beforeStage') {
      this.setState({
        beforeStage: !this.state.beforeStage,
        beforeStageIcon: this.state.beforeStageIcon === 'up' ? 'down' : 'up'
      });
    } else if (stage === 'middleStage') {
      this.setState({
        middleStage: !this.state.middleStage,
        middleStageIcon: this.state.middleStageIcon === 'up' ? 'down' : 'up'
      });
    } else if (stage === 'afterStage') {
      this.setState({
        afterStage: !this.state.afterStage,
        afterStageIcon: this.state.afterStageIcon === 'up' ? 'down' : 'up'
      });
    }
  };

  /**
   * 获取助手类型
   */
  _commonAideType = () => {
    let initialValue = this.initialValue;
    let aideTypeList = this.aideTypeList;
    const {name, startDate, endDate} = initialValue;
    let className = "班级：";
    if (name) {
      className = className + name;
    }
    let classDate = "时间：";
    if (startDate && endDate) {
      classDate = classDate + startDate + "  ~" + endDate;
    }
    const title = () =>
      <span>
        <span style={{float: 'left', width: '40%'}}>{className}</span>
        <span style={{float: 'left'}}>{classDate}</span>
      </span>;
    let cardProps = {
      title: title(),
      icon: '0',
      headStyle: {backgroundColor: '#f8f8f8', color: '#3a3a3a',},
    };

    return (
      <WizCard {...cardProps}>
        {
          !aideTypeList ? <WizEmpty image={WizEmpty.PRESENTED_IMAGE_SIMPLE}/> : this._getAideTypeCommon(aideTypeList)
        }
      </WizCard>
    )
  };

  _getAideImg = (aideType)=>{
    switch (aideType.code) {
      case 'smallClass':
          return constants.files.sys_classAide_smallClass_png;
      case 'questionnaire':
          return constants.files.sys_classAide_questionnaire_png;
      case 'sign':
          return constants.files.sys_classAide_sign_png;
      case 'exam':
          return constants.files.sys_classAide_exam_png;
      case 'homework':
          return constants.files.sys_classAide_homework_png;
      case 'satisfaction':
          return constants.files.sys_classAide_satisfaction_png;
      case 'remoteAuth':
          return constants.files.sys_classAide_remoteAuth_png;
      case 'remoteEvaluation':
          return constants.files.sys_classAide_remoteEvaluation_png;
      case 'onlineProgram':
          return constants.files.sys_classAide_onlineProgram_png;
      case 'NEVLive':
          return constants.files.sys_classAide_remoteAuth_png;
      case 'NEVMeeting':
          return constants.files.sys_classAide_smallClass_png;
    }
  }

  /**
   * 渲染助手类型
   */
  _getAideTypeCommon = (aideTypeList) => {
    return aideTypeList.map((aideType) => {
      let src = this._getAideImg(aideType);
      return (
        <CheckableTag key={aideType.id && aideType.id} checked={false} onChange={(checked) => {
          this._handleAideTypeTag(checked, aideType, {})
        }}>
          <WizCard bordered={true} hoverable size={'small'}
                   bodyStyle={{textAlign: 'center', verticalAlign: 'middle', padding: 0,}}
                   key={aideType.id} style={{width: 180}}
          >
            <ul className="ant-card-actions"
                style={{textAlign: 'center', verticalAlign: 'middle', border: 0, background: '#FFFFFF'}}>
              <li style={{width: '50%'}}>
                <WizAvatar  src={src} style={{
                backgroundColor: (aideType.color && aideType.color),
                marginLeft: '30%'
              }}/>
              </li>
              <li style={{width: '50%',paddingTop:'5px'}}>
                {aideType.name && aideType.name}
                </li>
            </ul>
          </WizCard>
        </CheckableTag>
      )
    });
  };

  /**
   * 获取班级已有流程环节
   */
  _commonClassAide = () => {
    let initialValue = this.initialValue;
    let allClassAideList = [];
    const {classAideList} = initialValue;
    if (classAideList && classAideList.length) {
      allClassAideList = [...classAideList];
    }

    let beforeAideList = [];
    let middleAideList = [];
    let afterAideList = [];
    allClassAideList.forEach(element => {
      element['stage'] === 0 ? beforeAideList.push(element) : element['stage'] === 1 ? middleAideList.push(element) : afterAideList.push(element)
    })

    let classAideCount = allClassAideList && allClassAideList.length ? allClassAideList.length : 0;
    let cardProps = {
      title: '已安排内容 （' + classAideCount + '）',
      icon: 'schedule',
      headStyle: {backgroundColor: '#f8f8f8', color: '#3a3a3a'},
      extra: <WizButton type="primary" onClick={this.changeOrderNum}>
        <WizIcon type="sort-ascending"/>调整顺序
      </WizButton>
    };
    let cardPropsBefore = {
      title: '课前 （' + (beforeAideList.length ? beforeAideList.length : 0) + '）',
      icon: 'schedule',
      headStyle: {backgroundColor: '#f8f8f8', color: '#3a3a3a'},
      extra: <WizButton style={{border: '0px', backgroundColor: '#f8f8f8'}} onClick={() => {
        this.isShowStage('beforeStage')
      }}>
        <WizIcon type={this.state.beforeStageIcon}/>
      </WizButton>
    };

    let cardPropsMiddle = {
      title: '课中 （' + (middleAideList.length ? middleAideList.length : 0) + '）',
      icon: 'schedule',
      headStyle: {backgroundColor: '#f8f8f8', color: '#3a3a3a'},
      extra: <WizButton style={{border: '0px', backgroundColor: '#f8f8f8'}} onClick={() => {
        this.isShowStage('middleStage')
      }}>
        <WizIcon type={this.state.middleStageIcon}/>
      </WizButton>
    };

    let cardPropsAfter = {
      title: '课后 （' + (afterAideList.length ? afterAideList.length : 0) + '）',
      icon: 'schedule',
      headStyle: {backgroundColor: '#f8f8f8', color: '#3a3a3a'},
      extra: <WizButton style={{border: '0px', backgroundColor: '#f8f8f8'}} onClick={() => {
        this.isShowStage('afterStage')
      }}>
        <WizIcon type={this.state.afterStageIcon}/>
      </WizButton>
    };

    let otherTopCardProps = {
      // title: '默认按照安排内容添加时间排序',
      icon: '0',
      type: 'inner',
      headStyle: {
        color: 'rgba(0, 0, 0, 0.85)',
        fontWeight: 500,
        background: '#FFFFFF',
        borderBottom: 0,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 50,
      },
      bodyStyle: {height: 0, padding: 0},
      style: {padding: 0}
    };
    if (!allClassAideList || !allClassAideList.length) {
      otherTopCardProps = null;
    }

    let stepsProps = {
      style: {paddingTop: 50},
      pending: false,
      reverse: this.state.reverse,
    };
    let stepProps = {};
    let renderItem = (data, index, datas, callback) => {
      let heightStyle = '150px';
      if (data.stage === 0 && (index + 1) === beforeAideList.length) {
        heightStyle = '80px';
      } else if (data.stage === 1 && (index + 1) === middleAideList.length) {
        heightStyle = '80px';
      } else if (data.stage === 2 && (index + 1) === afterAideList.length) {
        heightStyle = '80px';
      }
      const {id} = data;
      callback({
        key: id + '_renderItem',
        color: data.status ===1 ? '#e5e5e5':'blue',
        dot: <WizAvatar size="small"
                        style={{
                          color: '#FFFFFF',
                          backgroundColor: data.status ===1 ? '#e5e5e5':'#4A90E2',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                        }}>{index + 1}</WizAvatar>
      });
      return this._getRenderItem(data, heightStyle)
    };

    let beforeShow = this.state.beforeStage ? <WizCommonSteps
      timelineProps={stepsProps}
      itemProps={stepProps}
      cardProps={cardPropsBefore}
      datas={beforeAideList}
      renderItem={renderItem}
      otherTopCardProps={null}
      //  renderEmpty={()=> null}
    /> : <WizCommonSteps cardProps={cardPropsBefore} otherTopCardProps={null} renderEmpty={() => null}/>

    let middleShow = this.state.middleStage ? <WizCommonSteps
      timelineProps={stepsProps}
      itemProps={stepProps}
      cardProps={cardPropsMiddle}
      datas={middleAideList}
      renderItem={renderItem}
      otherTopCardProps={null}
      // renderEmpty={()=> null}
    /> : <WizCommonSteps cardProps={cardPropsMiddle} otherTopCardProps={null} renderEmpty={() => null}/>

    let afterShow = this.state.afterStage ? <WizCommonSteps
      timelineProps={stepsProps}
      itemProps={stepProps}
      cardProps={cardPropsAfter}
      datas={afterAideList}
      renderItem={renderItem}
      otherTopCardProps={null}
      // renderEmpty={()=> null}
    /> : <WizCommonSteps cardProps={cardPropsAfter} otherTopCardProps={null} renderEmpty={() => null}/>

    return (
      <>
        {/* <WizCommonSteps
    timelineProps={stepsProps}
    itemProps={stepProps}
    cardProps={cardProps}
    datas={allClassAideList}
    renderItem={renderItem}
    otherTopCardProps={otherTopCardProps}
  /> */}
        {beforeShow}{middleShow}{afterShow}
      </>
    )
  };

  /**
   * 获取流程环节渲染内容
   */
  _getRenderItem = (classAide, heightStyle) => {
    return (
      <div
        style={{
          height: heightStyle,
          position: 'relative',
          top: -34,
          marginLeft: 10
        }}
      >{this._getRenderClassAide(classAide)}</div>
    )
  };

  /**
   * 获取单个流程环节渲染内容
   */
  _getRenderClassAide = (classAide) => {
    let nameTitle = classAide.aideName;
    const {id, classId, className, aideTypeId, aideTypeName, entityId, orderNum, status, statusShow, entityRecord} = classAide;
    let surveyTypeName = "";
    if (entityRecord && entityRecord.type == 0) {
      surveyTypeName = "普通问卷"
    } else if (entityRecord && entityRecord.type == 1) {
      surveyTypeName = "随堂问卷"
    } else if (entityRecord && entityRecord.type == 2) {
      surveyTypeName = "回执问卷"
    } else {
      surveyTypeName = "满意度问卷"
    }
    let renderAideTypeName = aideTypeName;
    // if (entityRecord && entityRecord['id']) {
    //   const { name, title } = entityRecord;
    //   if (name) {
    //     nameTitle = name;
    //   } else if (title) {
    //     nameTitle = title;
    //   }
    // } else {
    //   nameTitle = aideTypeName;
    // }

    let statusStr = null;
    switch (statusShow) {
      case 1:
        statusStr = <span style={{float: 'left'}}> <code
          style={{backgroundColor: '#a6a6a6', color: '#ffffff', fontSize: 10}}>{'已关闭'}</code></span>
        break;
      case 2:
        statusStr = <span style={{float: 'left'}}><code
          style={{backgroundColor: '#ffc300', color: '#ffffff', fontSize: 10}}>{'未开始'}</code></span>
        break;
      case 3:
        statusStr = <span style={{float: 'left'}}><code
          style={{backgroundColor: '#43cf7c', color: '#ffffff', fontSize: 10}}>{'进行中'}</code></span>
        break;
      case 4:
        statusStr = <span style={{float: 'left'}}><code
          style={{backgroundColor: '#ff5733', color: '#ffffff', fontSize: 10}}>{'已结束'}</code></span>
        break;
    }

    let survey = aideTypeId == 2 ?
      <span style={{
        float: 'left',
        marginLeft: 10,
        fontSize: 10,
        fontWeight: 500,
        color: '#3a3a3a'
      }}>{surveyTypeName}</span> : <></>;
    let classAideCard = () => {
      let title = () =>
        <span>
          {statusStr}
          <span
            style={{float: 'left', marginLeft: 10, fontSize: 13, fontWeight: 500, color: '#3a3a3a'}}>{nameTitle}</span>
          {/* {survey} */}
        </span>;
      let cardProps = {
        title: title(),
        icon: '0',
        size: 'small',
        style: {marginLeft: 2, height: 100},
        headStyle: {
          height: '33%',
          fontSize: 12,
          color: 'rgba(0, 0, 0, 0.85)',
          fontWeight: 500,
          background: status===1 ? '#e5e5e5' : '#FFFFFF',
          borderBottom: 0,
        },
        bodyStyle: {
          textAlign: 'center', verticalAlign: 'middle', padding: 0, margin: 0, height: '67%',background: status===1 ? '#e5e5e5' : undefined,
        },
        extra: this.classAideCardButtons(classAide),
      };
      return (
        <WizCard {...cardProps}>
          {this.classAideRow(classAide)}
        </WizCard>
      )
    };
    return (
      <WizCard bordered={true} bodyStyle={{height: 120, padding: 0}} style={{marginLeft: 30,background : status===1 ? '#e5e5e5':undefined }}>
        <div>
          <div style={{
            width: '10%', height: 100, float: 'left', position: 'relative',
            textAlign: 'center', verticalAlign: 'center'
          }}>
            <p className="center-vertical center-horizontal center-margin">
              {
                (status === 0) ? <WizButton type="link"
                                            size="small">{"[" + renderAideTypeName + "]"}</WizButton> : "[" + renderAideTypeName + "]"
              }
            </p>
          </div>
          <div style={{width: '90%', height: 100, float: 'left'}}>
            <WizDivider className="divider-style" type="vertical"/>
            {classAideCard()}
          </div>
        </div>
      </WizCard>
    )
  };

  /**
   * 按钮组渲染
   */
  classAideCardButtons(classAide) {
    let children = this._classAideCardButtons(classAide);
    let relMaxNum = 5;
    return (
      <div onClick={e => e.stopPropagation()}>
        {(children && children.length > relMaxNum) ? (
          <>
            <Row>
              <Col span={19}>
                {children.slice(0, relMaxNum)}
              </Col>
              <Col span={5}>
                <div style={{height: '100%', padding: 0, marginLeft: '-80%'}}>
                  <WizDropdown.Button type="link"
                                      placement="bottomRight"
                                      overlay={this._createMenu(children.slice(relMaxNum, children.length), classAide)}
                  />
                </div>
              </Col>
            </Row>
          </>
        ) : (
          children
        )}
      </div>
    )
  }

  /**
   * 按钮多余变下拉菜单
   */
  _createMenu(children, classAide) {
    const {id} = classAide;
    return (
      <WizMenu style={{textAlign: 'center'}}>
        {children.map((val, index) => (
          <WizMenu.Item key={val.key || index}>{val}</WizMenu.Item>
        ))}
      </WizMenu>
    );
  };

  /**
   * 按钮组
   */
  _classAideCardButtons(classAide) {
    let aideTypeMap = this.aideTypeMap;
    const {id, classId, aideTypeId, entityRecord, status} = classAide;
    let aideType = aideTypeMap[aideTypeId];
    if (!aideType) {
      return;
    }
    const {code} = aideType;
    if (!code) {
      return;
    }
    //status 代表 0:启用,1:禁用/关闭
    let enableName = '关闭';
    let tipAll = "";
    if (status != null && status === 1) {
      enableName = '打开';
      tipAll = "请先打开环节,再进行编辑!";
    }
    // entityRecord 若有特殊数据 需要单独处理
    if (code === 'smallClass') {
      const {state,videoTool} = entityRecord;
      let tipInfo = status? "直播课堂已关闭,无法重新打开此环节,可重新创建新的直播课堂环节" : undefined;
      let buttons = [];
      buttons.push(<WizButton key={id + "_edit" + aideTypeId} type="link" size="small" disabled={status}
                              onClick={e => this.buttonOperation(classAide, 'edit')}>编辑</WizButton>)
      buttons.push(<WizDivider key={id + "_1_" + aideTypeId} type="vertical" style={{padding: 0, margin: 0}}/>)
      buttons.push(<WizButton key={id + "_enable" + aideTypeId} type="link" size="small" style={{paddingRight: '-15'}} tooltip={tipInfo} disabled={status}
                              onClick={e => this.buttonOperation(classAide, 'enable')}>{enableName}</WizButton>)
      buttons.push(<WizDivider key={id + "_2_" + aideTypeId} type="vertical" style={{padding: 0, margin: 0}}/>)
      buttons.push(<WizButton key={id + "_look_" + aideTypeId} type="link" size="small"
                              onClick={e => this.buttonOperation(classAide, 'look')}>参训记录</WizButton>)
      // buttons.push(<WizButton key={id + "_state_2_" + aideTypeId} type="link" size="small" disabled={(!(state === 1) || status)} style={{width:'100%'}}
      //                                      onClick={e => this.buttonOperation(classAide, 'state', 2)}>预告</WizButton>) ;
      // buttons.push(<WizButton key={id + "_state_3_" + aideTypeId} type="link" size="small" disabled={!(state === 1 || state === 2 )|| status} style={{width:'100%'}}
      //                                      onClick={e => this.buttonOperation(classAide, 'state', 3)}>发布</WizButton>) ;
      buttons.push(<WizButton key={id + "_state_4_" + aideTypeId} type="link" size="small" disabled={(!(state === 3))||status} style={{width:'100%'}}
                                           onClick={e => this.buttonOperation(classAide, 'state', 4)}>关闭直播</WizButton>) ;
      buttons.push(<WizButton key={id + "_export" + aideTypeId} size="small" style={{width:'100%'}}
                              onClick={e => this.buttonOperation(classAide, 'exportRecord')}>导出参训记录</WizButton>)
      buttons.push(<WizButton key={id + "_videoPlayback" + aideTypeId} size="small" style={{width:'100%'}} disabled={videoTool==2}
                              onClick={e => this.buttonOperation(classAide, 'videoPlayback')}>录像回放</WizButton>)
      return buttons;
    } else if (code === 'remoteEvaluation') {
      //远程评估
      const {state} = entityRecord;
      let tipInfo = status? "远程评估已关闭,无法重新打开此环节,可重新创建新的远程评估环节" : undefined;
      let buttons = [];
      buttons.push(<WizButton key={id + "_edit" + aideTypeId} type="link" size="small" disabled={status}
                              onClick={e => this.buttonOperation(classAide, 'edit')}>编辑</WizButton>)
      buttons.push(<WizDivider key={id + "_1_" + aideTypeId} type="vertical" style={{padding: 0, margin: 0}}/>)
      buttons.push(<WizButton key={id + "_enable" + aideTypeId} type="link" size="small" style={{paddingRight: '-15'}} tooltip={tipInfo} disabled={status}
                              onClick={e => this.buttonOperation(classAide, 'enable')}>{enableName}</WizButton>)
      buttons.push(<WizDivider key={id + "_2_" + aideTypeId} type="vertical" style={{padding: 0, margin: 0}}/>)
      buttons.push(<WizButton key={id + "_look_" + aideTypeId} type="link" size="small"
                              onClick={e => this.buttonOperation(classAide, 'look')}>评估记录</WizButton>)
      buttons.push(<WizButton key={id + "_state_2_" + aideTypeId} type="link" size="small" disabled={(!(state === 1) || status)} style={{width:'100%'}}
                                           onClick={e => this.buttonOperation(classAide, 'state', 2)}>预告</WizButton>) ;
      buttons.push(<WizButton key={id + "_state_3_" + aideTypeId} type="link" size="small" disabled={!(state === 1 || state === 2 )|| status} style={{width:'100%'}}
                                           onClick={e => this.buttonOperation(classAide, 'state', 3)}>发布</WizButton>) ;
      buttons.push(<WizButton key={id + "_state_4_" + aideTypeId} type="link" size="small" disabled={(!(state === 3))||status} style={{width:'100%'}}
                                           onClick={e => this.buttonOperation(classAide, 'state', 4)}>关闭直播</WizButton>) ;
      buttons.push(<WizButton key={id + "_export" + aideTypeId} size="small" style={{width:'100%'}}
                              onClick={e => this.buttonOperation(classAide, 'exportRecord')}>导出评估记录</WizButton>)
      buttons.push(<WizButton key={id + "_videoPlayback" + aideTypeId} size="small" style={{width:'100%'}}
                              onClick={e => this.buttonOperation(classAide, 'videoPlayback')}>录像回放</WizButton>)
      return buttons;
    } else if (code === 'remoteAuth') {
      //远程认证
      let tipInfo = status? "远程认证已关闭,无法重新打开此环节,可重新创建新的远程认证环节" : undefined;
      let buttons = [];
      buttons.push(<WizButton key={id + "_edit" + aideTypeId} type="link" size="small" disabled={status}
                              onClick={e => this.buttonOperation(classAide, 'edit')}  tooltip={tipAll}  >编辑</WizButton>)
      buttons.push(<WizDivider key={id + "_1_" + aideTypeId} type="vertical" style={{padding: 0, margin: 0}}/>)
      buttons.push(<WizButton key={id + "_enable" + aideTypeId} type="link" size="small" style={{paddingRight: '-15'}}  tooltip={tipInfo} disabled={status}
                              onClick={e => this.buttonOperation(classAide, 'enable')}>{enableName}</WizButton>)
      buttons.push(<WizDivider key={id + "_2_" + aideTypeId} type="vertical" style={{padding: 0, margin: 0}}/>)
      buttons.push(<WizButton key={id + "_look_" + aideTypeId} type="link" size="small"
                              onClick={e => this.buttonOperation(classAide, 'look')}>认证管理</WizButton>)
      buttons.push(<WizButton key={id + "_export" + aideTypeId} size="small"
                              onClick={e => this.buttonOperation(classAide, 'exportAuthRecord')}>导出认证记录</WizButton>)
      return buttons;
    } else if (code === 'questionnaire') {
      let entityInfo = {...entityRecord};
      if (entityRecord && entityRecord['startDate'] && entityRecord['endDate']) {
        const {id, title, startDate, endDate} = entityRecord;
        let surveyDate = null;
        if (startDate && endDate) {
          surveyDate = [];
          surveyDate[0] = startDate;
          surveyDate[1] = endDate;
        }
        entityInfo['classDate'] = surveyDate;
        entityInfo['name'] = title;
      }
      classAide['entityRecord'] = entityInfo;
      return [
        <WizButton key={id + "_look_" + aideTypeId} type="link" size="small"
                   onClick={e => this.buttonOperation(classAide, 'look')}>查看</WizButton>,
        <WizDivider key={id + "_1_" + aideTypeId} type="vertical" style={{padding: 0, margin: 0}}/>,
        <WizButton key={id + "_edit" + aideTypeId} type="link" size="small" disabled={status}
                   onClick={e => this.buttonOperation(classAide, 'edit')} tooltip={tipAll}  >编辑</WizButton>,
        <WizDivider key={id + "_2_" + aideTypeId} type="vertical" style={{padding: 0, margin: 0}}/>,
        <WizButton key={id + "_enable" + aideTypeId} type="link" size="small" style={{paddingRight: '-15'}}
                   onClick={e => this.buttonOperation(classAide, 'enable')}>{enableName}</WizButton>,
        <WizButton key={id + "_delete" + aideTypeId} size="small"
                   onClick={e => this.buttonOperation(classAide, 'delete')}>删除</WizButton>,
        <WizButton key={id + "_export" + aideTypeId} size="small"
                   onClick={e => this.buttonOperation(classAide, 'exportSurvey')}>导出答卷信息</WizButton>,
        // <WizButton key={id + "_downQRCode" + aideTypeId} size="small"
        //   onClick={e => this.buttonOperation(classAide, 'downQRCode')}>下载二维码</WizButton>,

      ]
    } else if (code === 'sign') {
      let entityInfo = {...entityRecord};
      if (entityRecord && entityRecord['signTimesList'] && entityRecord['signTimesList'].length) {
        const {signTimesList} = entityRecord;
        const {id, startDate, endDate} = signTimesList[0];
        let signDate = null;
        if (startDate && endDate) {
          signDate = [];
          signDate[0] = startDate;
          signDate[1] = endDate;
        }
        entityInfo['signTimesId'] = id;
        entityInfo['signDate'] = signDate;
      }
      classAide['entityRecord'] = entityInfo;
      return [
        <WizButton key={id + "_look_" + aideTypeId} type="link" size="small"
                   onClick={e => this.buttonOperation(classAide, 'look')}>查看</WizButton>,
        <WizDivider key={id + "_1_" + aideTypeId} type="vertical" style={{padding: 0, margin: 0}}/>,
        <WizButton key={id + "_edit" + aideTypeId} type="link" size="small" disabled={status}
                   onClick={e => this.buttonOperation(classAide, 'edit')} tooltip={tipAll} >编辑</WizButton>,
        <WizDivider key={id + "_2_" + aideTypeId} type="vertical" style={{padding: 0, margin: 0}}/>,
        <WizButton key={id + "_sign" + aideTypeId} type="link" size="small" style={{paddingRight: '-15'}}
                   onClick={e => this.buttonOperation(classAide, 'signRepair')}>补签</WizButton>,
        <WizButton key={id + "_enable" + aideTypeId} size="small"
                   onClick={e => this.buttonOperation(classAide, 'enable')}>{enableName}</WizButton>,
        <WizButton key={id + "_delete" + aideTypeId} size="small"
                   onClick={e => this.buttonOperation(classAide, 'delete')}>删除</WizButton>,
        // <WizButton key={id + "_downQRCode" + aideTypeId} size="small"
        //   onClick={e => this.buttonOperation(classAide, 'downQRCode')}>下载二维码</WizButton>,
      ]
    } else if (code === 'exam') {
      let entityInfo = {...entityRecord};
      if (entityRecord && entityRecord['startDate'] && entityRecord['endDate']) {
        const {id, title, startDate, endDate} = entityRecord;
        let examDate = null;
        if (startDate && endDate) {
          examDate = [];
          examDate[0] = startDate;
          examDate[1] = endDate;
        }
        entityInfo['classDate'] = examDate;
        entityInfo['name'] = title;
      }
      classAide['entityRecord'] = entityInfo;
      return [

        <WizButton key={id + "_edit" + aideTypeId} type="link" size="small" disabled={status}
                   onClick={e => this.buttonOperation(classAide, 'edit')} tooltip={tipAll} >编辑</WizButton>,
        <WizDivider key={id + "_1_" + aideTypeId} type="vertical" style={{padding: 0, margin: 0}}/>,
        <WizButton key={id + "_enable" + aideTypeId} type="link" size="small" style={{paddingRight: '-15'}}
                   onClick={e => this.buttonOperation(classAide, 'enable')}>{enableName}</WizButton>,
        <WizDivider key={id + "_2_" + aideTypeId} type="vertical" style={{padding: 0, margin: 0}}/>,
        <WizButton key={id + "_look_" + aideTypeId} type="link" size="small"
                   onClick={e => this.buttonOperation(classAide, 'look')}>考试记录</WizButton>,
        <WizButton key={id + "_export" + aideTypeId} size="small"
                   onClick={e => this.buttonOperation(classAide, 'export')}>导出考试成绩</WizButton>,
        // <WizButton key={id + "_downQRCode" + aideTypeId} size="small"
        //   onClick={e => this.buttonOperation(classAide, 'downQRCode')}>下载二维码</WizButton>,
      ]
    } else if (code === 'question') {
      return [
        <WizButton key={id + "_look_" + aideTypeId} type="link" size="small"
                   onClick={e => this.buttonOperation(classAide, 'look')}>查看</WizButton>,
        <WizDivider key={id + "_1_" + aideTypeId} type="vertical" style={{padding: 0, margin: 0}}/>,
        <WizButton key={id + "_edit" + aideTypeId} type="link" size="small" disabled={status}
                   onClick={e => this.buttonOperation(classAide, 'edit')} tooltip={tipAll}>编辑</WizButton>,
        <WizDivider key={id + "_2_" + aideTypeId} type="vertical" style={{padding: 0, margin: 0}}/>,
        <WizButton key={id + "_enable" + aideTypeId} type="link" size="small" style={{paddingRight: '-15'}}
                   onClick={e => this.buttonOperation(classAide, 'enable')}>{enableName}</WizButton>,
        <WizButton key={id + "_delete" + aideTypeId} size="small"
                   onClick={e => this.buttonOperation(classAide, 'delete')}>删除</WizButton>,
        <WizButton key={id + "_export" + aideTypeId} size="small"
                   onClick={e => this.buttonOperation(classAide, 'export')}>导出提问</WizButton>,
      ]
    } else if (code === 'homework') {
      return [
        <WizButton key={id + "_edit" + aideTypeId} type="link" size="small" disabled={status}
                   onClick={e => this.buttonOperation(classAide, 'edit')} tooltip={tipAll} >编辑</WizButton>,
        <WizDivider key={id + "_1_" + aideTypeId} type="vertical" style={{padding: 0, margin: 0}}/>,
        <WizButton key={id + "_enable" + aideTypeId} type="link" size="small" style={{paddingRight: '-15'}}
                   onClick={e => this.buttonOperation(classAide, 'enable')}>{enableName}</WizButton>,
        <WizDivider key={id + "_2_" + aideTypeId} type="vertical" style={{padding: 0, margin: 0}}/>,
        <WizButton key={id + "_look_" + aideTypeId} type="link" size="small"
                   onClick={e => this.buttonOperation(classAide, 'look')}>作业记录</WizButton>,
        <WizButton key={id + "_export" + aideTypeId} size="small"
                   onClick={e => this.buttonOperation(classAide, 'exportHomework')}>导出作业记录</WizButton>,
                  //  <WizButton key={id + "_delete" + aideTypeId} size="small"
                  //  onClick={e => this.buttonOperation(classAide, 'delete')}>删除</WizButton>,
      ]
    } else if (code === 'satisfaction') {
      return [
        <WizButton key={id + "_edit" + aideTypeId} type="link" size="small" disabled={status}
                   onClick={e => this.buttonOperation(classAide, 'edit')} tooltip={tipAll} >编辑</WizButton>,
        <WizDivider key={id + "_1_" + aideTypeId} type="vertical" style={{padding: 0, margin: 0}}/>,
        <WizButton key={id + "_enable" + aideTypeId} type="link" size="small" style={{paddingRight: '-15'}}
                   onClick={e => this.buttonOperation(classAide, 'enable')}>{enableName}</WizButton>,
        <WizDivider key={id + "_2_" + aideTypeId} type="vertical" style={{padding: 0, margin: 0}}/>,
        <WizButton key={id + "_look_" + aideTypeId} type="link" size="small"
                   onClick={e => this.buttonOperation(classAide, 'look')}>满意度问卷记录</WizButton>,
        <WizButton key={id + "_export" + aideTypeId} size="small"
                   onClick={e => this.buttonOperation(classAide, 'exportSatisfaction')}>导出问卷记录</WizButton>,
                  //  <WizButton key={id + "_delete" + aideTypeId} size="small"
                  //  onClick={e => this.buttonOperation(classAide, 'delete')}>删除</WizButton>,
      ]
    }else if (code === 'NEVMeeting') {
      const {state} = entityRecord;
      let tipInfo = status? "直播课堂已关闭,无法重新打开此环节,可重新创建新的直播课堂环节" : undefined;
      let buttons = [];
      buttons.push(<WizButton key={id + "_edit" + aideTypeId} type="link" size="small" disabled={status}
                              onClick={e => this.buttonOperation(classAide, 'edit')}>编辑</WizButton>)
      buttons.push(<WizDivider key={id + "_1_" + aideTypeId} type="vertical" style={{padding: 0, margin: 0}}/>)
      buttons.push(<WizButton key={id + "_enable" + aideTypeId} type="link" size="small" style={{paddingRight: '-15'}} tooltip={tipInfo} disabled={status}
                              onClick={e => this.buttonOperation(classAide, 'enable')}>{enableName}</WizButton>)
      buttons.push(<WizDivider key={id + "_2_" + aideTypeId} type="vertical" style={{padding: 0, margin: 0}}/>)
      buttons.push(<WizButton key={id + "_look_" + aideTypeId} type="link" size="small"
                              onClick={e => this.buttonOperation(classAide, 'look')}>参训记录</WizButton>)
      // buttons.push(<WizButton key={id + "_state_2_" + aideTypeId} type="link" size="small" disabled={(!(state === 1) || status)} style={{width:'100%'}}
      //                                      onClick={e => this.buttonOperation(classAide, 'state', 2)}>预告</WizButton>) ;
      // buttons.push(<WizButton key={id + "_state_3_" + aideTypeId} type="link" size="small" disabled={!(state === 1 || state === 2 )|| status} style={{width:'100%'}}
      //                                      onClick={e => this.buttonOperation(classAide, 'state', 3)}>发布</WizButton>) ;
      // buttons.push(<WizButton key={id + "_state_4_" + aideTypeId} type="link" size="small" disabled={(!(state === 3))||status} style={{width:'100%'}}
      //                                      onClick={e => this.buttonOperation(classAide, 'state', 4)}>关闭直播</WizButton>) ;
      buttons.push(<WizButton key={id + "_export" + aideTypeId} size="small" style={{width:'100%'}}
                              onClick={e => this.buttonOperation(classAide, 'exportRecord')}>导出参训记录</WizButton>)
      // buttons.push(<WizButton key={id + "_videoPlayback" + aideTypeId} size="small" style={{width:'100%'}}
      //                         onClick={e => this.buttonOperation(classAide, 'videoPlayback')}>录像回放</WizButton>)
      return buttons;
    }else if (code === 'NEVLive') {
      //远程认证
      let tipInfo = status? "NEV认证已关闭,无法重新打开此环节,可重新创建新的NEV认证环节" : undefined;
      let buttons = [];
      buttons.push(<WizButton key={id + "_edit" + aideTypeId} type="link" size="small" disabled={status}
                              onClick={e => this.buttonOperation(classAide, 'edit')}  tooltip={tipAll}  >编辑</WizButton>)
      buttons.push(<WizDivider key={id + "_1_" + aideTypeId} type="vertical" style={{padding: 0, margin: 0}}/>)
      buttons.push(<WizButton key={id + "_enable" + aideTypeId} type="link" size="small" style={{paddingRight: '-15'}} tooltip={tipInfo} disabled={status}
                              onClick={e => this.buttonOperation(classAide, 'enable')}>{enableName}</WizButton>)
      buttons.push(<WizDivider key={id + "_2_" + aideTypeId} type="vertical" style={{padding: 0, margin: 0}}/>)
      buttons.push(<WizButton key={id + "_look_" + aideTypeId} type="link" size="small"
                              onClick={e => this.buttonOperation(classAide, 'look')}>认证管理</WizButton>)
      buttons.push(<WizButton key={id + "_export" + aideTypeId} size="small"
                              onClick={e => this.buttonOperation(classAide, 'exportNEVAuthRecord')}>导出认证记录</WizButton>)
      return buttons;
    }
  }

  /**
   * 按钮组操作
   */
  buttonOperation(classAide, operation, value) {
    let aideTypeMap = this.aideTypeMap;
    const {id, classId, aideTypeName, aideTypeCode, aideTypeId, entityRecord, url, status, entityId, aideName, startTime, endTime, stage,pushEnterpriseNumber,appIds} = classAide;
    let aideType = null;
    if (aideTypeMap[aideTypeId]) {
      aideType = aideTypeMap[aideTypeId];
    } else {
      aideType = {
        code: aideTypeCode,
        id: aideTypeId,
        name: aideTypeName,
        url: url,
      }
    }
    let startDateAide = new Date(startTime);
    let endDateAide = new Date(endTime);
    let classDate = [];
    classDate[0] = startDateAide;
    classDate[1] = endDateAide;
    let entityInfo = {
      ...entityRecord,
      aideTypeId: aideTypeId,
      classId,
      appIds,
      classAideId: id,
      pushEnterpriseNumber,
      aideName,
      startTime,
      endTime,
      stage,
      status,
      classDate,
      aideTypeName
    };
    if (operation === 'look' && url) {
      this.jumpPage('push', url, {...entityInfo});
    } else if (operation === 'edit') {
      let other = {
        entityRecord: entityInfo,
        classAideId: id
      };
      //打开编辑模态框
      this._handleAideTypeTag(true, aideType, other);
      //打开、关闭操作
    } else if (operation === 'enable') {
      //* 状态{0:打开,1:关闭} 2为未开始 3为进行中 4已结束, 后台接口会根据当前时间判断打开状态下实际的进行状态
      let newStatus = status != null && status === 1 ? 0 : 1;
      this._updateClassAideStatus(id, newStatus,aideTypeName,aideTypeId,entityId,classId);
    } else if (operation === 'delete') {
      this._deleteClassAide(id);
    } else if (operation === 'signRepair') {
      const {id, signTimesList} = entityRecord;
      let signTime = '';
      if (signTimesList && signTimesList.length) {
        const {startDate, endDate} = signTimesList[0];
        if (startDate && endDate) {
          signTime = startDate + " ~" + endDate;
        }
      }
      this._signRepairClassStudent(id, signTime)
    } else if (operation === 'export') {
      this._exportClassStudentExam(classId, entityId);
    } else if (operation === 'exportSurvey') {
      this._exportClassStudentSurveyDetailByCondition(classId, entityId);
    } else if (operation === 'exportRecord') {

      if (aideTypeName==='直播课堂'){
        this.setState({
          excelName:'环节参训记录信息'
        })
      }else if (aideTypeName==='远程评估'){
        this.setState({
          excelName:'环节评估记录信息'
        })
      }
      //导出认证评估、直播课堂记录
      this._exportClassStudentInteractLive(classId, entityId,id,aideTypeId);
    } else if (operation === 'exportAuthRecord') {
      //导出认证远程记录
      this._exportClassStudentRemoteAuth(classId, entityId,id,aideTypeId);
    } else if (operation === 'exportNEVAuthRecord') {
      //导出认证远程记录
      this._exportClassStudentNEVRemoteAuth(classId, entityId,id,aideTypeId);
    } else if (operation === 'exportHomework'){
      this._exportClassStudentHomework(classId, entityId,id);
    } else if (operation === 'exportSatisfaction'){
      this._exportClassStudentSatisfaction(classId, entityId,id);
    } else if (operation === 'state'){
      this._setInteractLiveState(value,entityId,aideTypeName);
    } else if (operation === 'videoPlayback'){
      this.setState({
        videoVisible:true,
        ownerId : entityRecord && entityRecord.ownerId ? entityRecord.ownerId  : undefined
      })
    }
  }

/**修改班级环节直播状态 */
_setInteractLiveState(value,entityId,aideTypeName) {
  let stateStr = value === 2 ? '预告': value === 3 ? "发布" : "关闭"
  WizModal.confirm({
    title: '注意',
    content: `您确定要${stateStr}该${aideTypeName}吗？`,
    onOk: () => {
      this.doAction({
        path: 'interactLive/setInteractLiveState',
        payload: {
          key: 'interactLive@setInteractLiveState',
          apiParams: {
            state: value,
            id: entityId,
          }
        }
      });
    },
    onCancel() {
    }
  });
}

/**导出班级学员作业记录 */
_exportClassStudentHomework(classId, entityId,classAideId) {
  this.doAction({
    path: 'classStudentHomework/exportClassStudentHomework',
    payload: {
      key: 'classAide@exportClassStudentHomework',
      apiParams: {
        classInfoId: classId,
        entityId: entityId,
        classAideId:classAideId,
      }
    }
  });
}

/**导出班级学员满意度问卷记录 */
_exportClassStudentSatisfaction(classId, entityId,classAideId) {
  this.doAction({
    path: 'classStudentSurvey/exportClassStudentSurveyByCondition',
    payload: {
      key: 'classAide@exportClassStudentSurveyByCondition',
      apiParams: {
        classInfoId: classId,
        surveyId: entityId,
        classAideId:classAideId,
      }
    }
  });
}

  /**导出班级学员直播课堂、远程认证记录 */
  _exportClassStudentInteractLive(classId, entityId,classAideId,aideTypeId) {
    this.doAction({
      path: 'classStudentManagement/interactLiveByList',
      payload: {
        key: 'classAide@classStudentLiveRecord',
        apiParams: {
          classInfoId: classId,
          entityId: entityId,
          classAideId:classAideId,
          aideTypeId:aideTypeId,
        }
      }
    });
  }

  /**导出班级学员远程评估记录 */
  _exportClassStudentRemoteAuth(classId, entityId,classAideId,aideTypeId) {
    this.doAction({
      path: 'classStudentManagement/remoteAuthByList',
      payload: {
        key: 'classAide@classStudentRemoteAuth',
        apiParams: {
          classInfoId: classId,
          entityId: entityId,
          classAideId:classAideId,
          aideTypeId:aideTypeId,
        }
      }
    });
  }

  /**导出班级学员NEV远程评估记录 */
  _exportClassStudentNEVRemoteAuth(classId, entityId,classAideId,aideTypeId) {
    this.doAction({
      path: 'classStudentManagement/NEVAuthByList',
      payload: {
        key: 'classAide@NEVAuthByList',
        apiParams: {
          classInfoId: classId,
          entityId: entityId,
          classAideId:classAideId,
          aideTypeId:aideTypeId,
        }
      }
    });
  }

  /**导出 */
  _exportClassStudentExam(classId, entityId) {
    this.doAction({
      path: 'classStudentExam/exportStudentExamByCondition',
      payload: {
        key: 'classAide@exportStudentExamByCondition',
        apiParams: {
          classInfoId: classId,
          examId: entityId
        }
      }
    });
  }

  /**导出问卷答题详情 */
  _exportClassStudentSurveyDetailByCondition(classId, entityId) {
    this.doAction({
      path: 'classStudentSurvey/exportClassStudentSurveyDetailByCondition',
      payload: {
        key: 'exportClassStudentSurveyDetailByCondition',
        apiParams: {
          classInfoId: classId,
          surveyId: entityId
        }
      }
    });
  }

  /**校验对应时间段是否有直播资源 */
  checkMeetingDate(startDate, endDate,meetingNo,type,videoTool) {
    this.doAction({
      path: 'interactLive/checkMeetingDate',
      payload: {
        key: 'interactLive@checkMeetingDate',
        apiParams: {
          startDate,
          endDate,
          meetingNo,
          type,
          videoTool
        }
      }
    });
  }

  /**
   * 加载流程快内容
   */
  classAideRow = (classAide) => {
    let aideTypeMap = this.aideTypeMap;
    const {id, classId, className, aideTypeId,aideTypeCode, aideTypeName, entityId, orderNum, status, entityRecord} = classAide;
    let aideType = aideTypeMap[aideTypeId];
    if (!aideType) {
      return;
    }
    const {code} = aideType;
    if (!code) {
      return;
    }
    let hasPerson = '';
    let noPerson = '';
    if (!aideTypeCode || aideTypeCode===undefined || aideTypeCode ===''){
      //默认
      let hasPerson = '已参加';
      let noPerson = '未参加';
    }else if (aideTypeCode==='smallClass'){
      //直播课堂
      hasPerson = '已参训';
      noPerson = '未参训';
    }else if (aideTypeCode==='remoteEvaluation'){
      //远程评估
      hasPerson = '已参与';
      noPerson = '未参与';
    }else if (aideTypeCode==='questionnaire'){
      //问卷
      hasPerson = '已答卷';
      noPerson = '未答卷';
    }else if (aideTypeCode==='sign'){
      //签到
      hasPerson = '已签到';
      noPerson = '未签到';
    }else if (aideTypeCode==='exam'){
      //考试
      hasPerson = '已参加';
      noPerson = '未参加';
    }else if (aideTypeCode==='question'){
      //提问
      hasPerson = '已参加';
      noPerson = '未参加';
    }else if (aideTypeCode==='homework'){
      //作业
      hasPerson = '已提交';
      noPerson = '未提交';
    }else if (aideTypeCode==='satisfaction'){
      //满意度问卷
      hasPerson = '已答卷';
      noPerson = '未答卷';
    }else if (aideTypeCode==='remoteAuth'){
      //远程认证
      hasPerson = '已参与';
      noPerson = '未参与';
    }else if (aideTypeCode==='onlineProgram'){
      //在线课程
      hasPerson = '已通过';
      noPerson = '未通过';
    }else if (aideTypeCode==='NEVLive'){
      hasPerson = '已评分';
      noPerson = '未评分';
    }else if (aideTypeCode==='NEVMeeting'){
      hasPerson = '已参训';
      noPerson = '未参训';
    }
    let classAideDate = '';
    if (classAide['startTime'] && classAide['endTime']) {
      classAideDate = classAide['startTime'] + " ~" + classAide['endTime'];
    }

    let respondents = entityRecord.respondents ? entityRecord.respondents : 0;
    let configPersonCount = entityRecord.configPersonCount ? entityRecord.configPersonCount : 0;
    let returnRender = [];
    if (aideTypeCode==='remoteAuth' || aideTypeCode==='NEVLive' ){
      returnRender = [
        <Row key={id + "_row_" + 1} className="row-first-style">
          <Col span={23} className="col-style"><span className="span-style">{'环节时间：'}</span>
            <span>{classAideDate}</span>
          </Col>
        </Row>,
        <Row key={id + "_row_" + 2} className="row-style">
          <Col span={4} className="col-left-style">
            <WizAvatar size={20} icon={'user'} style={{
              backgroundColor: '#90bf92',
              marginLeft: '2.5%'
            }}/><span className="span-left-style">{respondents + '人'+hasPerson}</span>
          </Col>
          <Col span={4} className="col-left-style">
            <WizAvatar size={20} icon={'user'} style={{
              backgroundColor: '#f995b6',
              marginLeft: '2.5%'
            }}/><span className="span-left-style">{(this.initialValue.studentCount - respondents) + '人'+noPerson}</span>
          </Col>
          <Col span={4} offset={7} className="col-left-style">
            <WizAvatar size={20} icon={'user'} style={{
              backgroundColor: '#90bf92',
              marginLeft: '2.5%'
            }}/><span className="span-left-style">{configPersonCount + '人已分配'}</span>
          </Col>
          <Col span={4} className="col-left-style">
            <WizAvatar size={20} icon={'user'} style={{
              backgroundColor: '#f995b6',
              marginLeft: '2.5%'
            }}/><span className="span-left-style">{(this.initialValue.studentCount - configPersonCount) + '人未分配'}</span>
          </Col>
        </Row>
      ]
    }else {
      returnRender = [
        <Row key={id + "_row_" + 1} className="row-first-style">
          <Col span={23} className="col-style"><span className="span-style">{'环节时间：'}</span>
            <span>{classAideDate}</span>
          </Col>
        </Row>,
        <Row key={id + "_row_" + 2} className="row-style">
          <Col span={4} className="col-left-style">
            <WizAvatar size={20} icon={'user'} style={{
              backgroundColor: '#90bf92',
              marginLeft: '2.5%'
            }}/><span className="span-left-style">{respondents + '人'+hasPerson}</span>
          </Col>
          <Col span={4} className="col-left-style">
            <WizAvatar size={20} icon={'user'} style={{
              backgroundColor: '#f995b6',
              marginLeft: '2.5%'
            }}/><span className="span-left-style">{(this.initialValue.studentCount - respondents) + '人'+noPerson}</span>
          </Col>
        </Row>
      ]
    }

    return returnRender;


    // if (code === 'smallClass') {
    //   const { startDate, duration } = entityRecord;
    //   return [
    //     <Row key={id + "_row_" + 1} className="row-first-style">
    //       <Col span={8} className="col-style"><span className="span-style">开始时间：</span>
    //         <span className="span-style">{startDate && startDate}</span>
    //       </Col>
    //       <Col span={15} className="col-style"><span className="span-style">预计时长：</span>
    //         <span className="span-style">{(duration ? duration : 0) + '分钟'}</span>
    //       </Col>
    //     </Row>,
    //     <Row key={id + "_row_" + 2} className="row-style">
    //       <Col span={8} className="col-style"><span className="span-style">互动环节：</span>
    //         <span className="span-style">{''}</span>
    //       </Col>
    //       <Col span={15} className="col-style"><span className="span-style">{'参与 人次'}</span>
    //       </Col>
    //     </Row>
    //   ]
    // } else if (code === 'questionnaire') {
    //   let questionnaireDate = null;
    //   if (entityRecord && entityRecord['startDate'] && entityRecord['endDate']) {
    //     const { id, startDate, endDate, type } = entityRecord;
    //     questionnaireDate = startDate + " ~" + endDate;
    //   }

    //   let typeStr = null;
    //   let respondents = entityRecord.respondents ? entityRecord.respondents : 0;
    //   return [
    //     <Row key={id + "_row_" + 1} className="row-first-style">
    //       <Col span={23} className="col-style"><span className="span-style">{'时间：'}</span>
    //         <span>{questionnaireDate}</span>
    //       </Col>
    //     </Row>,
    //     <Row key={id + "_row_" + 2} className="row-style">
    //       <Col span={4} className="col-left-style">
    //         <WizAvatar size={20} icon={'user'} style={{
    //           backgroundColor: '#90bf92',
    //           marginLeft: '2.5%'
    //         }} /><span className="span-left-style">{respondents + '人参与'}</span>
    //       </Col>
    //       <Col span={4} className="col-left-style">
    //         <WizAvatar size={20} icon={'user'} style={{
    //           backgroundColor: '#f995b6',
    //           marginLeft: '2.5%'
    //         }} /><span className="span-left-style">{(this.initialValue.studentCount - respondents) + '人未参与'}</span>
    //       </Col>
    //     </Row>
    //   ]
    // } else if (code === 'sign') {
    //   let signDate = null;
    //   const { id, signCount, noSignCount, signTimesList } = entityRecord;
    //   if (entityRecord && entityRecord['signTimesList'] && entityRecord['signTimesList'].length) {
    //     const { signId, startDate, endDate } = signTimesList[0];
    //     if (startDate && endDate) {
    //       signDate = startDate + " ~" + endDate;
    //     }
    //   }

    //   return [
    //     <Row key={id + "_row_" + 1} className="row-first-style">
    //       <Col span={23} className="col-style"><span className="span-style">{'1.签到时间段：'}</span>
    //         <span className="span-style">{signDate}</span>
    //       </Col>
    //     </Row>,
    //     <Row key={id + "_row_" + 2} className="row-style">
    //       <Col span={4} className="col-left-style">
    //         <WizAvatar size={20} icon={'user'} style={{
    //           backgroundColor: '#90bf92',
    //           marginLeft: '2.5%'
    //         }} /><span className="span-left-style">{signCount + '人已签到'}</span>
    //       </Col>
    //       <Col span={4} className="col-left-style">
    //         <WizAvatar size={20} icon={'user'} style={{
    //           backgroundColor: '#f995b6',
    //           marginLeft: '2.5%'
    //         }} /><span className="span-left-style">{noSignCount + '人未签到'}</span>
    //       </Col>
    //     </Row>
    //   ]
    // } else if (code === 'exam') {
    //   let examDate = null;
    //   if (entityRecord && entityRecord['startDate'] && entityRecord['endDate']) {
    //     const { id, startDate, endDate, } = entityRecord;
    //     examDate = startDate + " ~" + endDate;
    //   }
    //   let respondents = entityRecord.respondents ? entityRecord.respondents : 0;
    //   return [
    //     <Row key={id + "_row_" + 1} className="row-first-style">
    //       <Col span={23} className="col-style"><span className="span-style">{'时间：'}</span>
    //         <span className="span-style">{examDate}</span>
    //       </Col>
    //     </Row>,
    //     <Row key={id + "_row_" + 2} className="row-style">
    //       <Col span={4} className="col-left-style">
    //         <WizAvatar size={20} icon={'user'} style={{
    //           backgroundColor: '#90bf92',
    //           marginLeft: '2.5%'
    //         }} /><span className="span-left-style">{respondents + '人参与'}</span>
    //       </Col>
    //       <Col span={4} className="col-left-style">
    //         <WizAvatar size={20} icon={'user'} style={{
    //           backgroundColor: '#f995b6',
    //           marginLeft: '2.5%'
    //         }} /><span className="span-left-style">{(this.initialValue.studentCount - respondents) + '人未参与'}</span>
    //       </Col>
    //     </Row>
    //   ]
    // } else if (code === 'question') {
    //   let questionDate = null;
    //   if (entityRecord && entityRecord['startDate'] && entityRecord['endDate']) {
    //     const { id, startDate, endDate, } = entityRecord;
    //     questionDate = startDate + " ~" + endDate;
    //   }
    //   if (!questionDate) {
    //     questionDate = "2020-02-25 15:54:46 ~2020-02-25 16:25:00";
    //   }
    //   return [
    //     <Row key={id + "_row_" + 1} className="row-first-style">
    //       <Col span={23} className="col-style"><span className="span-style">{'时间：'}</span>
    //         <span className="span-style">{questionDate}</span>
    //       </Col>
    //     </Row>,
    //     <Row key={id + "_row_" + 2} className="row-style">
    //       <Col span={4} className="col-left-style">
    //         <WizAvatar size={20} icon={'user'} style={{
    //           backgroundColor: '#90bf92',
    //           marginLeft: '2.5%'
    //         }} /><span className="span-left-style">{'10人参与'}</span>
    //       </Col>
    //       <Col span={4} className="col-left-style">
    //         <WizAvatar size={20} icon={'user'} style={{
    //           backgroundColor: '#f995b6',
    //           marginLeft: '2.5%'
    //         }} /><span className="span-left-style">{'10人未参与'}</span>
    //       </Col>
    //     </Row>
    //   ]
    // }
  };

  /**
   * 加载流程快modal内容
   */
  _getEntityInfoModal = () => {
    const modalFormProps = this._chooseModal();
    return (<WizModalForm {...modalFormProps} />)
  };

  /**
   *
   * 设置直播附属信息值,未传则全部设置默认值
   */
  _changeInteractLiveValue = (form) => {
    form.setFieldsValue({
      autoRecording: 0,
      hostVideo: 0,
      participantVideo: 0,
      waitingRoom: 0,
      muteUponEntry: 0,
      joinBeforeHost: 0,
      isHostCamera: [0],
      isHostMic: [0],
      isParticipantPlatform: [1],
      // isAllowCamera: [1],
      // isParticipantCamera: [0],
      // isAllowMic: [1],
      // isParticipantMic: [0],
      // isHallMode: [0],
      // isFollowHost: [0],
      // isModifyResume: [0],
    })
    setTimeout(()=>{
      form.setFieldsValue({
        isAllowCamera: [1],
        isParticipantCamera: [0],
        isAllowMic: [1],
        isParticipantMic: [0],
        isHallMode: [0],
        isFollowHost: [0],
        isModifyResume: [0],
      })
    },0)

  }

  /**
   * 选择加载打开的modal内容
   */
  _chooseModal = () => {
    const {
      smallClassVisible, questionnaireVisible, signVisible, examVisible,
      questionVisible, entityRecord, aideTypeId, classId, classAideId,pushEnterpriseNumber,
      coverImageShow, liveImg, homeworkVisible, aideName, startTime, endTime,
      stage, status, classDate, satisfactionVisible, remoteAuthVisible,labelInfo,NEVLiveVisible,NEVMeetingVisible
    } = this.state;
    let classAideDefaultDate = [];
    if(this.initialValue.startDate && this.initialValue.endDate){
      classAideDefaultDate.push(this.initialValue.startDate);
      classAideDefaultDate.push(this.initialValue.endDate);
    }
    let _classDate = null;
    let _remoteAuthIdList = this.remoteAuthIdList;
    let _remoteAuthIdListNEV = this.remoteAuthIdListNEV;
    if (entityRecord && entityRecord.startTime && entityRecord.endTime) {
      _classDate = [];
      _classDate.push(entityRecord.startTime);
      _classDate.push(entityRecord.endTime);
    }
    let aideEntity = {aideName, startTime, endTime, stage, status, classDate}
    let initialValue = this.initialValue;
    const {name, startDate, endDate} = initialValue;
    let startDateSign = new Date(startDate);
    let endDateSign = new Date(startDate);
    startDateSign.setHours(startDateSign.getHours() - 1);
    endDateSign.setMinutes(endDateSign.getMinutes() + 30);
    let signDate = [];
    signDate[0] = startDateSign;
    signDate[1] = endDateSign;
    let examDate = [];
    let surveyDate = [];
    let liveType = null;
    if (aideName != null && aideName === '直播课堂') {
      liveType = 5;
    } else if (aideName != null && aideName === '远程评估') {
      liveType = 6;
    } else if (aideName != null && aideName === '网络小课堂'){
      liveType = 10;
    }
    const _columnsVideo = columnsVideo(this, {
      name: entityRecord && entityRecord.name ? entityRecord.name : name,
      aideTypeId,
      classId,
      classAideId,
      classDate: _classDate,
      hostId: entityRecord && entityRecord.hostId ? entityRecord.hostId : null,
      hostName: entityRecord && entityRecord.hostName ? entityRecord.hostName : null,
      lookingBack: entityRecord && entityRecord.lookingBack ? entityRecord.lookingBack : 0,
      personIds: this.state.personIds,
      liveType: liveType,
      stage: entityRecord && entityRecord.stage ? entityRecord.stage : 1,
      state: entityRecord && entityRecord.state ? entityRecord.state : 1,
      status: entityRecord && entityRecord.status ? entityRecord.status : 0,
      autoRecording: entityRecord && entityRecord.autoRecording ? entityRecord.autoRecording : 0,
      hostVideo: entityRecord && entityRecord.hostVideo ? entityRecord.hostVideo : 0,
      participantVideo: entityRecord && entityRecord.participantVideo ? entityRecord.participantVideo : 0,
      waitingRoom: entityRecord && entityRecord.waitingRoom ? entityRecord.waitingRoom : 0,
      muteUponEntry: entityRecord && entityRecord.muteUponEntry ? entityRecord.muteUponEntry : 0,
      joinBeforeHost: entityRecord && entityRecord.joinBeforeHost ? entityRecord.joinBeforeHost : 0,
      ownerId : entityRecord && entityRecord.ownerId ? entityRecord.ownerId : null,
      classAideDefaultDate : classAideDefaultDate,
      img:entityRecord && entityRecord.img ? entityRecord.img : null,
      isHostCamera :  entityRecord && (entityRecord.isHostCamera===1 || entityRecord.isHostCamera===0)? entityRecord.isHostCamera : undefined,
      isHostMic : entityRecord && (entityRecord.isHostMic===1 || entityRecord.isHostMic===0)? entityRecord.isHostMic : undefined,
      isParticipantPlatform : entityRecord && (entityRecord.isParticipantPlatform===1 || entityRecord.isParticipantPlatform===0)? entityRecord.isParticipantPlatform : 1,
      isAllowCamera : entityRecord && (entityRecord.isAllowCamera===1 || entityRecord.isAllowCamera===0)? entityRecord.isAllowCamera : 1,
      isParticipantCamera : entityRecord && (entityRecord.isParticipantCamera===1 || entityRecord.isParticipantCamera===0)? entityRecord.isParticipantCamera : undefined,
      isAllowMic : entityRecord && (entityRecord.isAllowMic===1 || entityRecord.isAllowMic===0)? entityRecord.isAllowMic : 1,
      isParticipantMic : entityRecord && (entityRecord.isParticipantMic===1 || entityRecord.isParticipantMic===0)? entityRecord.isParticipantMic : undefined,
      isFollowHost : entityRecord && (entityRecord.isFollowHost===1 || entityRecord.isFollowHost===0)? entityRecord.isFollowHost : undefined,
      videoTool : entityRecord && entityRecord.videoTool
    });
    const _columnsQuestionnaire = columnsQuestionnaire(this, {
      classDate: _classDate,
      aideTypeId,
      classId,
      classAideId,
      entityRecord
    });
    const _columnsExam = columnsExam(this, {
      classDate: _classDate,
      aideTypeId,
      classId,
      classAideId,
      examDate,
      name,
      entityRecord,
      classAideDefaultDate : classAideDefaultDate
    });
    const _columnsSign = columnsSign(this, {
      aideTypeId,
      classId,
      classAideId,
      signDate,
      classDate: _classDate,
      status: entityRecord && entityRecord.status ? entityRecord.status : 0
    });
    const _columnsQuestion = columnsQuestion(this, {
      classDate: _classDate,
      aideTypeId,
      classId,
      classAideId,
      surveyDate,
      name
    });
    const _columnsHomework = columnsHomework(this, {
      classDate: _classDate,
      aideTypeId,
      classId,
      classAideId, ...aideEntity,
      entityRecord,
      classAideDefaultDate : classAideDefaultDate
    });
    const _columnsSatisfaction = columnsSatisfaction(this, {
      aideTypeId,
      labelInfo:labelInfo,
      classDate: _classDate,
      classId,pushEnterpriseNumber,
      classAideId, ...aideEntity,
      entityRecord,
      classAideDefaultDate : classAideDefaultDate
    });
    const _columnsRemoteAuth = columnsRemoteAuth(this, {
      name: entityRecord && entityRecord.name ? entityRecord.name : '',
      aideName: entityRecord && entityRecord.aideName ? entityRecord.aideName : name,
      aideTypeId,
      classId,
      classAideId,
      classDate: _classDate,
      remoteAuthIdList:_remoteAuthIdList,
      stage: entityRecord && entityRecord.stage ? entityRecord.stage : 1,
      id: entityRecord && entityRecord.id ? entityRecord.id : null,
      status: entityRecord && entityRecord.status ? entityRecord.status : 0,
      classAideDefaultDate : classAideDefaultDate
    });
    const _columnsNEVLive = columnsNEVLive(this, {
      name: entityRecord && entityRecord.name ? entityRecord.name : '',
      aideName: entityRecord && entityRecord.aideName ? entityRecord.aideName : name,
      aideTypeId,
      classId,
      classAideId,
      classDate: _classDate,
      remoteAuthIdList:_remoteAuthIdListNEV,
      stage: entityRecord && entityRecord.stage ? entityRecord.stage : 1,
      id: entityRecord && entityRecord.id ? entityRecord.id : null,
      status: entityRecord && entityRecord.status ? entityRecord.status : 0,
      classAideDefaultDate : classAideDefaultDate
    });
    const _columnsNEVMeeting = columnsNEVMeeting(this, {
      name: entityRecord && entityRecord.name ? entityRecord.name : name,
      aideTypeId,
      classId,
      classAideId,
      classDate: _classDate,
      hostId: entityRecord && entityRecord.hostId ? entityRecord.hostId : null,
      hostName: entityRecord && entityRecord.hostName ? entityRecord.hostName : null,
      lookingBack: entityRecord && entityRecord.lookingBack ? entityRecord.lookingBack : 0,
      personIds: this.state.personIds,
      liveType: liveType,
      stage: entityRecord && entityRecord.stage ? entityRecord.stage : 1,
      state: entityRecord && entityRecord.state ? entityRecord.state : 1,
      status: entityRecord && entityRecord.status ? entityRecord.status : 0,
      autoRecording: entityRecord && entityRecord.autoRecording ? entityRecord.autoRecording : 0,
      hostVideo: entityRecord && entityRecord.hostVideo ? entityRecord.hostVideo : 0,
      participantVideo: entityRecord && entityRecord.participantVideo ? entityRecord.participantVideo : 0,
      waitingRoom: entityRecord && entityRecord.waitingRoom ? entityRecord.waitingRoom : 0,
      muteUponEntry: entityRecord && entityRecord.muteUponEntry ? entityRecord.muteUponEntry : 0,
      joinBeforeHost: entityRecord && entityRecord.joinBeforeHost ? entityRecord.joinBeforeHost : 0,
      ownerId : entityRecord && entityRecord.ownerId ? entityRecord.ownerId : null,
      classAideDefaultDate : classAideDefaultDate,
      img:entityRecord && entityRecord.img ? entityRecord.img : null,
    });
    let columns = null;
    let title = null;
    let visible = false;
    let stateType = {};
    title = (entityRecord ? '修改' : '新增') + '环节-' + aideName;
    if (smallClassVisible) {
      columns = [..._columnsVideo];
      visible = smallClassVisible;
      stateType = {smallClassVisible: false};
    } else if (questionnaireVisible) {
      columns = [..._columnsQuestionnaire];
      visible = questionnaireVisible;
      stateType = {questionnaireVisible: false};

    } else if (signVisible) {
      columns = [..._columnsSign];
      visible = signVisible;
      stateType = {signVisible: false};
    } else if (examVisible) {
      columns = [..._columnsExam];
      visible = examVisible;
      stateType = {examVisible: false};
    } else if (questionVisible) {
      columns = [..._columnsQuestion];
      visible = questionVisible;
      stateType = {questionVisible: false};
    } else if (homeworkVisible) {
      columns = [..._columnsHomework];
      visible = homeworkVisible;
      stateType = {homeworkVisible: false};
    } else if (satisfactionVisible) {
      columns = [..._columnsSatisfaction];
      visible = satisfactionVisible;
      stateType = {satisfactionVisible: false};
    } else if (remoteAuthVisible) {
      columns = [..._columnsRemoteAuth];
      visible = remoteAuthVisible;
      stateType = {remoteAuthVisible: false};
    }else if (NEVLiveVisible) {
      columns = [..._columnsNEVLive];
      visible = NEVLiveVisible;
      stateType = {NEVLiveVisible: false};
    }else if (NEVMeetingVisible) {
      columns = [..._columnsNEVMeeting];
      visible = NEVMeetingVisible;
      stateType = {NEVMeetingVisible: false};
    }
    const modalFormProps = {
      title: title,
      loading: false,
      record: entityRecord,
      visible: visible,
      columns: columns,
      modalOpts: {
        width: 750
      },
      onCancel: () => {
        this.setState({
          ...stateType,
          modalClassAideKey: new Date().getTime(),
          entityRecord: null,
          aideTypeId: null,
          homeworkDate: undefined,
          homeworkName: undefined,
          satisfactionName: undefined,
          examName : undefined,
          classAideId : undefined,
          pushEnterpriseNumber:0,
          checkDateInfo : undefined,
          showHkt: false,
        });
      },
      onSubmit: (values, record) => {
        this._submitEntity(values, aideTypeId, stateType, record);
      }
    };
    return modalFormProps
  };

  /**
   * 上传图片
   */
  _changeImg = (info) => {
    let file = info[0].file;
    if (this._beforeUpload(file, false)) {
      this._getBase64(file.originFileObj, imageUrl => {
        this.setState({
          coverImageShow: imageUrl
        }, () => {
          //数据改变回调

        })
      })
    }
  };

  /**
   * 随机改变图片
   */
  _randomImg = () => {
    this.setState({
      coverImageShow: constants.files.sys_live_default_image
    })
  };

  /**
   * 上传文件前的钩子：自定义校验
   */
  _beforeUpload = (file, showMessage = true) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng && showMessage) {
      message.error('请上传类型为JPG或者PNG的图片');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M && showMessage) {
      message.error('图片不得超过2MB!');
    }
    return isJpgOrPng && isLt2M;
  };

  _onClassStudentSignCancel = (e) => {
    this.setState({
      signRepairVisible: false,
      signId: null,
      signTime: '',
    });
  };

  //选择人员弹出框确定按钮事件
  _saveRepairStudentSign = (obj, e) => {
    let idList = [];
    if (obj && obj['valueRows'] && obj['valueRows'] instanceof Array && obj['valueRows'].length > 0) {
      obj['valueRows'].forEach(key => {
        const {id} = key;
        idList.push(id);
      });
      if (idList && idList.length) {
        WizModal.confirm({
          title: '注意',
          content: '您确认对该批学员进行补签吗？',
          onOk: () => {
            this.doAction({
              path: 'studentSign/setStudentSignStatusByBatch',
              payload: {
                key: 'setStudentSignStatusByBatch',
                apiParams: {
                  idList: idList,
                  status: 2,
                }
              }
            });
          },
          onCancel() {
          }
        });
      } else {
        this.setState({
          signRepairVisible: false,
          signId: null,
          signTime: '',
        });
      }
    }
  };

  /**直播选择讲师 */
  renderLecturerValue(value, valueRows) {
    return (
      <div>  {valueRows && valueRows[0] && valueRows[0].userName ? valueRows[0].userName : ''}</div>
    )
  }

  /**查看问卷 */
  _onLookSurveyTemp(record) {
    this.setState({tempPreviewVisible: true, templateData: record})
  }

  _render() {
    const {classAideManagementLoading, aideTypeManagementLoading, classStudentSurveyLoading, classStudentExamLoading} = this.props;
    const {signRepairVisible, signId, signTime} = this.state;
    const _classStudentSignConfig = WizTableForm.Config.classStudentSign(this, {
      apiParams: {
        status: 0,
        signId: signId
      }
    });
    let title = '学员补签（签到时间段:' + signTime + ')';
    if (signTime == null || signTime === '') {
      title = '学员补签';
    }
    let tableFormProps = {
      title: title,
      showModal: true,
      showSelectValue: false,
      visible: signRepairVisible,
      selectType: 'checkbox',
      initRows: [],
      value: [],
      onSubmit: this._saveRepairStudentSign,
      onCancel: this._onClassStudentSignCancel,
    };

    let videoVisible = this.state.videoVisible;
    const modalProps = {
      title: "录像回看",
      footer: null,
      visible: videoVisible,
      width:700,
      onCancel: () => { this.setState({ videoVisible: false }) },
    };
    let record = {};
    record.ownerId = this.state.ownerId;
    return (
      <>
        <WizCard className="class-aide-detail">
          <Spin tip={'加载中'}
                spinning={classAideManagementLoading || aideTypeManagementLoading || classStudentSurveyLoading || classStudentExamLoading}>
            {this._commonAideType()}
            {this._commonClassAide()}
          </Spin>
        </WizCard>
        {this._getEntityInfoModal()}
        <div style={{position: "fixed", zIndex: 1000}}>
          <WizModal destroyOnClose
                    key={new Date().getTime()}
                    width={700} title={"问卷模版预览"}
                    visible={this.state.tempPreviewVisible}
                    onOk={() => {
                      this.setState({tempPreviewVisible: false})
                    }}
                    onCancel={() => {
                      this.setState({tempPreviewVisible: false})
                    }}
          >
            <SurveyTemplatePreview templateData={this.state.templateData}/>
          </WizModal>
        </div>
        <React.Fragment>
        <WizModal {...modalProps}>
          <AuthVideo key={'authVideo-' +record.ownerId } type={0} record={record} />
        </WizModal>
      </React.Fragment>

        <WizTableForm key={new Date().getTime()} {..._classStudentSignConfig} {...tableFormProps} />

      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {classAideManagement, classStudentManagement, aideTypeManagement, personManage, studentSign, classStudentExam, classStudentSurvey,classStudentHomework,interactLive,thirdApp} = state;
  const classAideList = modelUtils.getModelEntity(classAideManagement, "classAideList");
  const aideTypeList = modelUtils.getModelEntity(aideTypeManagement, "aideTypeList");
  const saveEntityInfo = modelUtils.getModelEntity(classAideManagement, "saveEntityInfo");
  const updateClassAideStatus = modelUtils.getModelEntity(classAideManagement, "updateClassAideStatus");
  const deleteClassAide = modelUtils.getModelEntity(classAideManagement, "deleteClassAide");
  const personInfo = modelUtils.getModelEntity(personManage, "getPersonInfoByPersonIdList");
  const setStudentSignStatusByBatch = modelUtils.getModelEntity(studentSign, "setStudentSignStatusByBatch");
  const load = modelUtils.getLoadingState(state, ['classAideManagement', 'aideTypeManagement', 'classStudentSurvey', 'classStudentExam']);
  const classStudentExamDetail = modelUtils.getModelEntity(classStudentExam, "classAide@exportStudentExamByCondition");
  const exportClassStudentSurveyDetailByCondition = modelUtils.getModelEntity(classStudentSurvey, "exportClassStudentSurveyDetailByCondition");
  const classStudentPersonIds = modelUtils.getModelEntity(classStudentManagement, "classStudentPersonIds");
  const classStudentRemoteAuth =  modelUtils.getModelEntity(classStudentManagement, "classAide@classStudentRemoteAuth");
  const classStudentNEVRemoteAuth =  modelUtils.getModelEntity(classStudentManagement, "classAide@NEVAuthByList");
  const classStudentLiveRecord =  modelUtils.getModelEntity(classStudentManagement, "classAide@classStudentLiveRecord");
  const exportClassStudentSurveyByCondition = modelUtils.getModelEntity(classStudentSurvey, "classAide@exportClassStudentSurveyByCondition");
  const exportClassStudentHomework = modelUtils.getModelEntity(classStudentHomework, "classAide@exportClassStudentHomework");
  const setInteractLiveState = modelUtils.getModelEntity(interactLive, "interactLive@setInteractLiveState");
  const checkMeetingDate = modelUtils.getModelEntity(interactLive, "interactLive@checkMeetingDate");
  const getClassInfoById = modelUtils.getModelEntity(classAideManagement, "getClassInfoById");
  const labelInfo = modelUtils.getModelEntity(thirdApp, "thirdApp@labelInfo");
  return {
    labelInfo:labelInfo,
    classAideList: classAideList,
    aideTypeList: aideTypeList,
    saveEntityInfo: saveEntityInfo,
    updateClassAideStatus: updateClassAideStatus,
    setStudentSignStatusByBatch: setStudentSignStatusByBatch,
    deleteClassAide: deleteClassAide,
    personInfo: personInfo,
    classStudentExamDetail: classStudentExamDetail,
    classStudentPersonIds: classStudentPersonIds,
    classStudentRemoteAuth:classStudentRemoteAuth,
    classStudentLiveRecord:classStudentLiveRecord,
    classStudentNEVRemoteAuth,
    exportClassStudentSurveyDetailByCondition,
    exportClassStudentSurveyByCondition,
    exportClassStudentHomework,
    setInteractLiveState,
    checkMeetingDate,
    getClassInfoById,
    ...load
  }
};

export default connect(mapStateToProps)(ClassAideDetail);
